import React, { Component } from "react";
import { NumericFormat } from 'react-number-format';
import FullCalendar from '@fullcalendar/react';
import AsyncSelect from 'react-select/async';
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import {Card, Form, Button, Row, Col, Table, Dropdown, Modal, Collapse, Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaDownload, FaEdit, FaTrash, FaCheck, FaTimes, FaReceipt, FaPlus, FaExclamationTriangle, FaFile } from "react-icons/fa";
import api from "../../services/api";
import { hasPerm, getCurrentUser, formataDataExibicao, formataCPF, calcularIdade, formatarValor, tiposArquivos, formataDataHoraExibicao, formataCNPJ, situacoesAgendamento, getDataAtual, formatarValorAPI, isLaudoBloqueadoParaUsuarioAtual } from '../../common/utils';
import { getConfig } from '../../common/config';
import { validarPdfMonitoramentoVns } from '../../common/pdfMonitoramento';
import ConfirmarRealizacaoModal from '../Modals/ConfirmarRealizacaoModal';
import ModalPersonalizadoServicos from '../Modals/ModalPersonalizadoServicos';
import FormularioEventoModal from '../Modals/FormularioEventoModal';
import eventosForm, { EVENTOS } from '../../services/eventosForm';
import moment from 'moment-timezone';

import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import interactionPlugin from "@fullcalendar/interaction" // needed for dayClick
import ptLocale from '@fullcalendar/core/locales/pt'; 

import { preventDefault } from "@fullcalendar/core/internal";
import listPlugin from '@fullcalendar/list';
import './fullcalendar-custom.css';

const situacaoAgendamento = [
    {
        label: "Solicitado",
        value: "solicitado",
        color: "default"
    },
    {
        label: "Liberado",
        value: "liberado",
        color: "primary"
    },
    {
        label: "Em análise",
        value: "em_analise",
        color: "warning"
    },
    {
        label: "Finalizado",
        value: "finalizado",
        color: "success"
    },
    {
        label: "Cancelado",
        value: "cancelado",
        color: "danger"
    }
]

class Agendas extends Component {
    constructor(props) {
        super(props);

        this.state = {
            agendamentos: [],
            error: "",
            beneficiario_id: "",
            dados_usuario: '',
            filtro_data_inicio: '',
            filtro_data_fim: '',
            loading: true,
            showModalAgendamento: false,
            evento_selecionado: [],
            showModalArquivosEdit: false,
            showModalAtualizarAgendamento: false,
            showModalArquivos: false,
            motivosCancelamento: [],
            motivoSelecionado: '',
            motivoOutro: '',
            arquivos: [],
            arquivo_id: null,
            arquivo_nome: '',
            arquivo_tipo: '',
            arquivo_aprovado: false,
            arquivo_upload: null,
            arquivoHelper: '',
            pendingArquivoUpload: null, // Stores payload/event for saving after form
            
            // Formulário de eventos (aprovação laudo)
            showFormularioEvento: false,
            formularioEvento: null,
            dadosFormularioEvento: null,

            showDespesasAgendamentosModal: false,
            despesasAgendamentosLoading: false,
            despesasAgendamentosErro: '',
            despesasAgendamentosRows: [],
            despesasAgendamentosAgendamentoId: null,

            despesasAgendamentosCategorias: [],
            despesasAgendamentosShowForm: false,
            despesasAgendamentosForm: { descricao: '', valor: '', data: '', despesa_categoria_id: '', categoria_outros: '', comprovanteFile: null},
            showConfirmarRealizacaoModal: false,
            showModalPersonalizadoServicos: false,
            agendamentoFormularioDinamico: null,
        };
    }

    

    componentDidMount(){
        setTimeout(() => {
            const calendarApi = this.calendarRef?.getApi();
            if (calendarApi) {
                const currentView = calendarApi.view;
                const startOfView = moment(currentView.activeStart).format('YYYY-MM-DD');
                const endOfView = moment(currentView.activeEnd).subtract(1, 'days').format('YYYY-MM-DD'); // -1 dia para ajustar o final real

                this.setState({
                    filtro_data_inicio: startOfView,
                    filtro_data_fim: endOfView
                }, () => {
                    this.buscaAgendas(false, 1);
                });
            }
        }, 100); // pequeno delay para garantir que o calendário montou
    }

    handleChangeFiltros = (event, fieldName) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    };

    handleEventClick = async (info) => {
        const props = info.event.extendedProps;

        if (props.source === 'acao') {
            const a = props.dados_acao || {};
            const dataHora = `${a.data_acao} ${a.hora_acao || ''}`.trim();
            let linkAtendimento = '';

            if (a.atendimento_id) {
                try {
                    // Mostra loading (NÃO usar await aqui)
                    Swal.fire({
                        title: "Carregando...",
                        allowOutsideClick: false,
                        didOpen: () => Swal.showLoading()
                    });

                    const resp = await api.get(`/atendimentos/${a.atendimento_id}/`);
                    const uuid = resp.data?.uuid;

                    if (uuid) {
                        linkAtendimento = `<p><a target="_blank" rel="noopener noreferrer" href="/atendimentos/edit/${uuid}">Abrir atendimento</a></p>`;
                    }
                    } catch (err) {
                        console.error("Erro ao buscar atendimento:", err);
                        linkAtendimento = `<p class="text-danger">Falha ao obter o atendimento</p>`;
                    } finally {
                    Swal.close(); // fecha o loading
                }

            }

            Swal.close(); // Fecha loading antes de abrir o modal final

            withReactContent(Swal).fire({
                title: a.dados_programa_acao?.nome || 'Ação',
                html: `
                    <div class="text-start text-small">
                        <p><strong>Descrição:</strong> ${a.descricao || '-'}</p>
                        <p><strong>Observações:</strong> ${a.observacoes || '-'}</p>
                        <p><strong>Data/Hora:</strong> ${formataDataHoraExibicao(dataHora)}</p>
                        <p><strong>Realizado:</strong> ${a.realizado ? 'Sim' : 'Não'}</p>
                        ${linkAtendimento}
                    </div>
                `,
                icon: 'info',
                confirmButtonText: 'Fechar',
                confirmButtonColor: '#3085d6',
            });

            return;
        }

        // fluxo antigo (agendamento)
        this.setState({
            showModalAgendamento: true,
            evento_selecionado: props,
            motivoSelecionado: props.dados_evento?.motivo_id || '',
            motivoOutro: props.dados_evento?.motivo_outro || '',
        });
    };



    editarArquivo = (arquivo) => {
        this.setState({
            arquivo_id: arquivo.id,
            arquivo_nome: arquivo.nome,
            arquivo_tipo: arquivo.tipo,
            arquivo_aprovado: arquivo.aprovado
        }, () => {
            this.handleShowModalArquivosEdit()
        })
    }

    excluirArquivo = (idArquivo) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: 'Excluir arquivo?',
            text: "Tem certeza que deseja excluir este arquivo? Você não poderá reverter isso!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ loading: true });
    
                api.delete(`/agendamentos/arquivos/${idArquivo}/`)
                    .then(response => {
                        MySwal.fire(
                            'Excluído!',
                            'O arquivo foi excluído com sucesso.',
                            'success'
                        );
                        // Remova o arquivo do estado para atualizar a UI
                        this.setState(prevState => ({
                            arquivos: prevState.arquivos.filter(arquivo => arquivo.id !== idArquivo),
                            loading: false
                        }));
                    })
                    .catch(error => {

                        MySwal.fire(
                            'Erro!',
                            'Houve um erro ao tentar excluir o arquivo. Por favor, tente novamente.',
                            'error'
                        );
                        this.setState({ loading: false });
                        //Sentry.captureException('Houve um erro ao tentar excluir o arquivo. Por favor, tente novamente.', error);
                    });
            }
        });
    }

    handleChangeAgendamentoEdit = (e, campo) => {
        const { value } = e.target; // Extrai o valor do evento.
    
        this.setState(prevState => ({
            evento_selecionado: {
                ...prevState.evento_selecionado, // Copia os valores existentes do agendamento selecionado.
                dados_evento: {
                    ...prevState.evento_selecionado.dados_evento, // Copia os valores existentes do agendamento selecionado.
                    [campo]: value // Atualiza o campo específico com o novo valor.
                }
            }
        }));
    }

    handleSituacaoChange = async (e) => {
        const situacao = e.target.value;
        // atualiza o agendamento selecionado
        this.handleChangeAgendamentoEdit(e, 'situacao');
      
        if (situacao === 'cancelado') {
          await this.fetchMotivosCancelamento();
        } else {
          // limpa tudo se não estiver mais em cancelado
          this.setState({ motivosCancelamento: [], motivoSelecionado: '', motivoOutro: '' });
        }
    }

    handleShowModalArquivos = () => {
        this.carregaArquivosAgendamento();
        this.setState({ showModalArquivos: true, showModalAgendamento: false });
    };

    handleCloseModalArquivos = () => {
        this.setState({ showModalArquivos: false, showModalAgendamento: true, arquivos: [] });
    };

    handleShowModalArquivosEdit = () => {
        this.handleCloseModalArquivos();
        this.setState({ showModalArquivosEdit: true, showModalAgendamento: false });
    };

    handleCloseModalAgendamento = () => {
        this.setState({
            showModalAgendamento: false,
            evento_selecionado: [],
            motivoSelecionado: '',
            motivoOutro: '',
        });
    }

    handleCloseModalAtualizarAgendamento = () => {
        this.setState({
            showModalAtualizarAgendamento: false,
            showModalAgendamento: true
        });
    }

    handleShowModalAtualizarAgendamento = () => {
        this.setState({
            showModalAtualizarAgendamento: true,
            showModalAgendamento: false,
            arquivos: []
        });
    }



    handleDateClick = (arg) => {
        //alert(arg.dateStr)
    }

    async buscaAgendas(e, page_numb = 1) {
        if (e) e.preventDefault();

        const dados_usuario = getCurrentUser();
        this.setState({ dados_usuario });

        const programa_id = dados_usuario['ambiente_programa_id'] || '';
        const isOperador  = (dados_usuario['tipo_usuario'] === 'operador');
        const { filtro_data_inicio, filtro_data_fim } = this.state;

        const arrColors = {
            cancelado:  '#FF5733',
            finalizado: '#28a745',
            solicitado: '#ffc107',
            liberado:   '#007bff',
            em_analise: '#ff9900',
        };

        const agUrl = `/agendamentos/?page=${page_numb}`
            + `&tipo_usuario=${dados_usuario['tipo_usuario']}`
            + `&data_inicio=${filtro_data_inicio}`
            + `&data_fim=${filtro_data_fim}`
            + `&programa_id=${programa_id}`;

        // monta URL de ações só se operador
        const acoesUrl = isOperador
            ? `/atendimentos/acoes/?data_inicio=${filtro_data_inicio}&data_fim=${filtro_data_fim}&programa_id=${programa_id}&limit=500`
            : null;

        this.setState({ loading: true, error: '' });

        try {
            const [agResp, acResp] = await Promise.all([
            api.get(agUrl),
            isOperador ? api.get(acoesUrl) : Promise.resolve(null),
            ]);

            // mapeia agendamentos → eventos
            const formattedAgEvents = (agResp.data.results || []).map(event => ({
                id: event.id,
                title: event.dados_servico_procedimento?.nome || "Evento sem descrição",
                start: event.data_agendamento,
                end:   event.data_agendamento,
                description: event.dados_servico_procedimento?.nome || "Serviço não disponível",
                backgroundColor: arrColors[event.situacao] || '#FFFFFF',
                // extendedProps que você já usa:
                dados_beneficiario: event.dados_beneficiario,
                dados_prestador: event.dados_prestador,
                dados_atendimento: event.dados_atendimento,
                dados_evento: event,
                beneficiario_id: event.beneficiario_id,
                agendamento_id: event.id,
                atendimento_id: event.atendimento_id,
                prestador_id: event.prestador_id,
                servico_procedimento_id: event.servico_procedimento_id,
                source: 'agendamento',
            }));

            // mapeia ações → eventos
            const acoes = isOperador ? (acResp?.data?.results || []) : [];
            const formattedAcEvents = this.mapAcoesToEvents(acoes);

            // mescla e joga no estado
            const allEvents = [...formattedAgEvents, ...formattedAcEvents];

            this.setState({
                agendamentos: allEvents,
                loading: false,
                error: '',
            });
        } catch (error) {
            let erro_msg = 'Erro ao consultar os dados, tente novamente.';
            if (error.response) {
            if (error.response.status === 500) erro_msg = 'Servidor indisponível no momento';
                else if (error.response.status === 403) erro_msg = 'Você não tem permissão para acessar essa área';
            } else {
                erro_msg = 'Erro na conexão com o servidor. Tente novamente mais tarde.';
            }
            this.setState({ loading: false, error: erro_msg });
        }
    }

    carregaArquivosAgendamento = () => {
        const agendamento_id = this.state.evento_selecionado.agendamento_id;
        if (agendamento_id) {
            api.get(`/agendamentos/arquivos/?agendamento_id=${agendamento_id}`)
                .then(response => {
                    const arquivosCarregados = response.data.results.map(dados => ({
                        id: dados.id,
                        nome: dados.nome,
                        arquivo: dados.arquivo,
                        agendamento_id: dados.agendamento_id,
                        data: dados.data,
                        aprovado: dados.aprovado,
                        tipo: dados.tipo,
                        motivo_recusa: dados.motivo_recusa,
                        cadastrado_por_id: dados.cadastrado_por_id
                    }));
                    this.setState({ arquivos: arquivosCarregados });
                })
                .catch(error => {
                    console.error('Erro ao carregar arquivos:', error);
                    
                    let erro_msg = 'Erro ao carregar arquivos do agendamento, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })

                    //Sentry.captureException(erro_msg);
                });
        }
    };

    saveArquivo = (e) => {
        e.preventDefault();

        const formData = new FormData();
        const MySwal = withReactContent(Swal);

        const { arquivo_upload, arquivo_nome, arquivo_tipo, arquivo_aprovado, arquivo_id, evento_selecionado, dadosFormularioEvento, pendingArquivoUpload } = this.state;
        const dados_usuario = getCurrentUser();

        // If this call is a continuation from a pending upload after form submission
        if (pendingArquivoUpload) {
            const { url, metodo, formData: storedFormData } = pendingArquivoUpload;
            if (dadosFormularioEvento) {
                storedFormData.append('dados_formulario_aprovacao', JSON.stringify(dadosFormularioEvento));
            }
            this.setState({ pendingArquivoUpload: null, dadosFormularioEvento: null }); // Clear pending state
            this.submitArquivoApi(url, metodo, storedFormData);
            return;
        }

        if (!arquivo_nome) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Por favor, informe um nome para o arquivo',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }

        const tipoArquivo = arquivo_tipo;
        if (!tipoArquivo) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Por favor, selecione um tipo do arquivo',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }
        
        this.setState({
            loading: true
        });

        if(!arquivo_id) {
            if (!arquivo_upload) {
                this.setState({
                    loading: false,
                });
    
                MySwal.fire({
                    icon: 'error',
                    showCloseButton: true,
                    title: "Atenção",
                    html: "Forneça um arquivo para enviar"
                }).then((result) => {
                    
                });
    
                return false;
            }
        }
        let url = '';
        let metodo = '';
        const agendamento_id = evento_selecionado.agendamento_id;

        url = (arquivo_id) ? `/agendamentos/arquivos/${arquivo_id}/` : '/agendamentos/arquivos/';
        metodo = (arquivo_id) ? 'put' : 'post';
        if(!arquivo_id) {
            const agora = moment().tz("America/Sao_Paulo"); // Garante o timezone de São Paulo
            const dataHoraAtualFormatada = agora.format("YYYY-MM-DD HH:mm:ss"); // Formata a data no padrão desejado

            formData.append('arquivo', arquivo_upload);
            formData.append('nome', arquivo_nome);
            formData.append('agendamento_id', agendamento_id);
            formData.append('data', dataHoraAtualFormatada);
            formData.append('aprovado', arquivo_aprovado);
            formData.append('tipo', tipoArquivo);
        } else {
            formData.append('nome', arquivo_nome);
            formData.append('aprovado', arquivo_aprovado);
            formData.append('tipo', tipoArquivo);
        }

        // --- Lógica de Aprovação Automática / Formulário ---
        // Se for Laudo, estiver marcando como aprovado (ou new upload default), e tiver formulario
        const isLaudo = tipoArquivo === 'laudo';
        const isAprovando = String(arquivo_aprovado) === 'true'; // Checkbox/Button logic
        
        // Verifica config do programa
        const eventoSel = evento_selecionado?.dados_evento;
        const dadosPrograma = eventoSel?.dados_programa || eventoSel?.dados_atendimento?.programa;
        const configPrograma = dadosPrograma?.configuracoes || {};
        const aprovaAutomatico = getConfig(configPrograma, 'aprova_laudo_automatico', false);

        // Se precisa de formulario e ainda não temos os dados
        if (isLaudo && aprovaAutomatico && isAprovando && !dadosFormularioEvento) {
             // Pausa o envio para verificar formulário
             this.setState({ loading: true });
             
             const programaId = dadosPrograma?.id || eventoSel?.programa_id;
             eventosForm.buscarFormularioEvento(EVENTOS.ON_APPROVE_LAUDO, programaId)
                .then(form => {
                    if (form) {
                        // Abre modal
                        this.setState({ 
                            loading: false,
                            showFormularioEvento: true,
                            formularioEvento: form,
                            // Store current upload data to resume after form submission
                            pendingArquivoUpload: { url, metodo, formData }
                        });
                        // O envio será retomado em handleFormularioEventoSuccess
                        return; 
                    } else {
                        // Sem formulário, prossegue envio normal
                        this.submitArquivoApi(url, metodo, formData);
                    }
                })
                .catch(err => {
                    console.error("Erro busca form evento", err);
                    // Erro na busca, tenta enviar assim mesmo (backend vai barrar se for obrigatorio)
                     this.submitArquivoApi(url, metodo, formData);
                });
             return; // Interrompe este fluxo
        }

        // Se tem dados do formulário, anexa
        if (dadosFormularioEvento) {
            formData.append('dados_formulario_aprovacao', JSON.stringify(dadosFormularioEvento));
        }

        this.submitArquivoApi(url, metodo, formData);
    };

    submitArquivoApi = (url, metodo, formData) => {
        const MySwal = withReactContent(Swal);
        api[metodo](url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(response => {
            let text_msg = '';
            if(this.state.tipo_arquivo_agendamento == 'monitoramento'){
                text_msg = 'Arquivo de monitoramento enviado com sucesso'
            } else {
                text_msg = (this.state.arquivo_id) ? 'Arquivo atualizado com sucesso' : 'Arquivo enviado com sucesso'
            }

            MySwal.fire({
                title: 'Sucesso',
                icon: 'success',
                html: text_msg,
                showCloseButton: true,
            })
            
            const evt = this.state.evento_selecionado?.dados_evento;
            // Se o status for 'arquivo_pendente', atualiza para 'finalizado'
            if (evt && evt.situacao === 'arquivo_pendente') {
                const payloadStatus = { situacao: 'finalizado' };
                // Usa o ID do agendamento (garantindo que pega o correto)
                const agendamentoId = evt.agendamento_id || evt.id; 
                api.patch(`/agendamentos/${agendamentoId}/`, payloadStatus)
                    .then(() => {
                         // Recarrega a agenda APÓS a atualização do status
                         this.buscaAgendas(false, 1);
                    })
                    .catch(e => console.error("Erro ao atualizar status", e))
                    .finally(() => {
                         // Garante que o loading para
                         this.setState({ loading: false });
                    });
            } else {
                // Se não precisar atualizar status, recarrega normal
                this.buscaAgendas(false, 1);
                this.setState({ loading: false });
            }

            this.carregaArquivosAgendamento();
            this.handleCloseModalArquivosEdit();

        })
        .catch(error => {
            let erro_msg = "Erro ao cadastrar arquivo, tente novamente";            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;     
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'arquivo'){
                        erro_msg += value;
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Atenção!',
                html: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })

            //Sentry.captureException(erro_msg);
        })
        .finally(() => {
            this.setState({ isSaving: false, showModalArquivosEdit: false });

        });
    }

    handleFormularioEventoSuccess = (respostas) => {
        this.setState({ 
            dadosFormularioEvento: respostas,
            showFormularioEvento: false 
        }, () => {
             // Re-submete o formulário de arquivo, agora com os dados
             // Precisamos de um evento fake ou refatorar saveArquivo. 
             // Simplesmente chamando saveArquivo com evento fake:
             this.saveArquivo({ preventDefault: () => {} });
        });
    };

    onChangeArquivo = (e) => {
        if (e.target.files && e.target.files[0]) {
            const arquivo_enviado = e.target.files[0];
            
            // Armazena o arquivo para upload
            this.setState({ arquivo_upload: arquivo_enviado });
        }
    };

    handleChange = (event, fieldName) => {
        this.setState({ [fieldName]: event.target.value });
    };

    handleCloseModalArquivosEdit = () => {
        this.setState({
            showModalArquivos: true,
            showModalArquivosEdit: false,
            arquivo_id: null,
            arquivo_nome: '',
            arquivo_tipo: '',
            arquivo_aprovado: false,
            arquivo_upload: null,
            arquivoHelper: '',
            dadosFormularioEvento: null, // limpa dados anteriores
            pendingArquivoUpload: null, // Clear any pending upload
        });
    }

    fetchMotivosCancelamento = async () => {
        const dados_usuario = getCurrentUser();
        const programa_id = dados_usuario.ambiente_programa_id || "";
        try {
          const resp = await api.get(`/agendamentos/motivos_cancelamento/?programa_id=${programa_id}`);
          this.setState({ motivosCancelamento: resp.data.results || [] });
        } catch (err) {
          console.error('Erro ao buscar motivos de cancelamento', err);
          this.setState({ motivosCancelamento: [] });
        }
    }

    handleAprovarArquivo = (arquivo_id) => {
        const MySwal = withReactContent(Swal);
        
        MySwal.fire({
            title: 'Aprovar Arquivo?',
            text: "Confirmar a aprovação deste documento?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3cc172',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, aprovar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ loading: true });
                api.put(`/agendamentos/arquivos/${arquivo_id}/`, { aprovado: true })
                    .then(() => {
                        this.setState({ loading: false });
                        MySwal.fire({
                            title: 'Sucesso', 
                            text: 'Arquivo aprovado.', 
                            icon: 'success',
                            timer: 2000,
                            showConfirmButton: false
                        });
                        this.carregaArquivosAgendamento();
                        this.buscaAgendas(false, 1);
                    })
                    .catch(error => {
                        this.setState({ loading: false });
                        const msg = error.response?.data?.detail || 'Não foi possível aprovar.';
                        MySwal.fire('Erro', msg, 'error');
                    });
            }
        });
    }

    handleRecusarArquivo = (arquivo_id) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: 'Recusar Arquivo',
            text: "Motivo da não aprovação (será enviado ao laboratório):",
            input: 'textarea',
            inputPlaceholder: 'Ex: Imagem ilegível, paciente incorreto...',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#eb4961',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Recusar e Notificar',
            inputValidator: (value) => {
                if (!value) return 'A justificativa é obrigatória!'
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                this.setState({ loading: true });
                api.put(`/agendamentos/arquivos/${arquivo_id}/`, {
                    aprovado: false,
                    motivo_recusa: result.value
                })
                .then(() => {
                    this.setState({ loading: false });
                    MySwal.fire({
                        title: 'Recusado', 
                        text: 'Laboratório notificado e status atualizado.', 
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    this.carregaArquivosAgendamento();
                    this.buscaAgendas(false, 1);
                })
                .catch(error => {
                    this.setState({ loading: false });
                    const msg = error.response?.data?.detail || 'Erro ao processar a recusa.';
                    MySwal.fire('Erro', msg, 'error');
                });
            }
        });
    }

    /**
     * Gera o HTML dos campos dinâmicos baseado na configuração
     * @param {Array} campos - Array de configuração de campos
     * @returns {string} HTML gerado
     */
    gerarHtmlCamposDinamicos = (campos) => {
        if (!campos || !Array.isArray(campos)) return '';

        return campos.map(campo => {
            const obrigatorioMark = campo.obrigatorio ? '<span class="text-danger">*</span>' : '';
            const observacao = campo.observacao ? `<small class="text-muted d-block mt-1">${campo.observacao}</small>` : '';

            switch (campo.tipo) {
                case 'file':
                    return `
                        <div class="mb-3 campo-dinamico" data-slug="${campo.slug}">
                            <label for="swal-campo-${campo.slug}" class="text-start d-block">${campo.label} ${obrigatorioMark}</label>
                            <input 
                                id="swal-campo-${campo.slug}" 
                                type="file" 
                                accept="${campo.extensoes || '.pdf,.jpg,.jpeg,.png'}"
                                class="swal2-file form-control" 
                                data-slug="${campo.slug}"
                                data-tipo="${campo.tipo}"
                                data-obrigatorio="${campo.obrigatorio || false}"
                            />
                            ${observacao}
                        </div>
                    `;
                
                case 'radio': {
                    const opcoesHtml = (campo.opcoes || []).map((opcao, idx) => {
                        const descricao = campo.descricoes_opcoes?.[opcao] 
                            ? `<small class="text-muted d-block ms-4">${campo.descricoes_opcoes[opcao]}</small>` 
                            : '';
                        return `
                            <div class="form-check">
                                <input 
                                    class="form-check-input" 
                                    type="radio" 
                                    name="swal-campo-${campo.slug}" 
                                    id="swal-campo-${campo.slug}-${idx}" 
                                    value="${opcao}"
                                    data-slug="${campo.slug}"
                                    data-tipo="${campo.tipo}"
                                />
                                <label class="form-check-label" for="swal-campo-${campo.slug}-${idx}">${opcao}</label>
                                ${descricao}
                            </div>
                        `;
                    }).join('');
                    
                    return `
                        <div class="mb-3 campo-dinamico" data-slug="${campo.slug}">
                            <label class="text-start d-block mb-2">${campo.label} ${obrigatorioMark}</label>
                            <div class="text-start" data-obrigatorio="${campo.obrigatorio || false}" data-obrigatorio-condicional='${JSON.stringify(campo.obrigatorio_condicional || null)}'>
                                ${opcoesHtml}
                            </div>
                            ${observacao}
                        </div>
                    `;
                }
                
                case 'text':
                    return `
                        <div class="mb-3 campo-dinamico" data-slug="${campo.slug}">
                            <label for="swal-campo-${campo.slug}" class="text-start d-block">${campo.label} ${obrigatorioMark}</label>
                            <input 
                                id="swal-campo-${campo.slug}" 
                                type="text" 
                                class="swal2-input" 
                                placeholder="${campo.placeholder || ''}"
                                data-slug="${campo.slug}"
                                data-tipo="${campo.tipo}"
                                data-obrigatorio="${campo.obrigatorio || false}"
                                data-obrigatorio-condicional='${JSON.stringify(campo.obrigatorio_condicional || null)}'
                            />
                            ${observacao}
                        </div>
                    `;
                
                case 'textarea':
                    return `
                        <div class="mb-3 campo-dinamico" data-slug="${campo.slug}">
                            <label for="swal-campo-${campo.slug}" class="text-start d-block">${campo.label} ${obrigatorioMark}</label>
                            <textarea 
                                id="swal-campo-${campo.slug}" 
                                class="swal2-textarea" 
                                placeholder="${campo.placeholder || ''}"
                                data-slug="${campo.slug}"
                                data-tipo="${campo.tipo}"
                                data-obrigatorio="${campo.obrigatorio || false}"
                                data-obrigatorio-condicional='${JSON.stringify(campo.obrigatorio_condicional || null)}'
                            ></textarea>
                            ${observacao}
                        </div>
                    `;
                
                default:
                    return '';
            }
        }).join('');
    };

    /**
     * Configura event listeners para campos com obrigatoriedade condicional
     * @param {HTMLElement} container - Container do modal
     * @param {Array} campos - Array de configuração de campos
     */
    configurarEventosCamposDinamicos = (container, campos) => {
        if (!campos || !Array.isArray(campos)) return;

        campos.forEach(campo => {
            if (campo.tipo === 'radio') {
                const radios = container.querySelectorAll(`input[name="swal-campo-${campo.slug}"]`);
                radios.forEach(radio => {
                    radio.addEventListener('change', () => {
                        this.atualizarObrigatoriedadeCondicional(container, campos);
                    });
                });
            }
        });
    };

    /**
     * Atualiza a obrigatoriedade condicional dos campos baseado nos valores selecionados
     * @param {HTMLElement} container - Container do modal
     * @param {Array} campos - Array de configuração de campos
     */
    atualizarObrigatoriedadeCondicional = (container, campos) => {
        campos.forEach(campo => {
            if (campo.obrigatorio_condicional) {
                const { campo: campoRef, valores } = campo.obrigatorio_condicional;
                const radioSelecionado = container.querySelector(`input[name="swal-campo-${campoRef}"]:checked`);
                const valorAtual = radioSelecionado?.value || '';
                
                const elementoCampo = container.querySelector(`#swal-campo-${campo.slug}`);
                const containerCampo = container.querySelector(`.campo-dinamico[data-slug="${campo.slug}"]`);
                
                if (elementoCampo && containerCampo) {
                    const isObrigatorio = valores.includes(valorAtual);
                    const labelEl = containerCampo.querySelector('label');
                    
                    if (labelEl) {
                        const spanObrig = labelEl.querySelector('.text-danger');
                        if (isObrigatorio && !spanObrig) {
                            labelEl.innerHTML = labelEl.textContent + ' <span class="text-danger">*</span>';
                        } else if (!isObrigatorio && spanObrig) {
                            spanObrig.remove();
                        }
                    }
                    
                    elementoCampo.dataset.obrigatorioAtual = isObrigatorio;
                }
            }
        });
    };

    /**
     * Coleta os valores de todos os campos dinâmicos
     * @param {Array} campos - Array de configuração de campos
     * @returns {Object} Objeto com slugs como chaves e valores preenchidos
     */
    coletarValoresCamposDinamicos = (campos) => {
        const valores = {};
        const arquivos = {};
        
        if (!campos || !Array.isArray(campos)) {
            return { valores, arquivos };
        }

        campos.forEach(campo => {
            switch (campo.tipo) {
                case 'file': {
                    const fileInput = document.getElementById(`swal-campo-${campo.slug}`);
                    if (fileInput?.files?.length > 0) {
                        arquivos[campo.slug] = fileInput.files[0];
                    }
                    break;
                }
                
                case 'radio': {
                    const radioSelecionado = document.querySelector(`input[name="swal-campo-${campo.slug}"]:checked`);
                    if (radioSelecionado) {
                        valores[campo.slug] = radioSelecionado.value;
                    }
                    break;
                }
                
                case 'text':
                case 'textarea': {
                    const inputEl = document.getElementById(`swal-campo-${campo.slug}`);
                    if (inputEl) {
                        valores[campo.slug] = inputEl.value.trim();
                    }
                    break;
                }
            }
        });

        return { valores, arquivos };
    };

    /**
     * Valida os campos dinâmicos obrigatórios
     * @param {Array} campos - Array de configuração de campos
     * @returns {string|null} Mensagem de erro ou null se válido
     */
    validarCamposDinamicos = (campos) => {
        if (!campos || !Array.isArray(campos)) {
            return null;
        }

        for (const campo of campos) {
            let isObrigatorio = campo.obrigatorio === true;
            
            if (campo.obrigatorio_condicional) {
                const { campo: campoRef, valores } = campo.obrigatorio_condicional;
                const radioSelecionado = document.querySelector(`input[name="swal-campo-${campoRef}"]:checked`);
                const valorAtual = radioSelecionado?.value || '';
                isObrigatorio = valores.includes(valorAtual);
            }

            if (!isObrigatorio) continue;

            switch (campo.tipo) {
                case 'file': {
                    const fileInput = document.getElementById(`swal-campo-${campo.slug}`);
                    if (!fileInput?.files?.length) {
                        return `Por favor, selecione um arquivo para "${campo.label}"`;
                    }
                    break;
                }
                
                case 'radio': {
                    const radioSelecionado = document.querySelector(`input[name="swal-campo-${campo.slug}"]:checked`);
                    if (!radioSelecionado) {
                        return `Por favor, selecione uma opção para "${campo.label}"`;
                    }
                    break;
                }
                
                case 'text':
                case 'textarea': {
                    const inputEl = document.getElementById(`swal-campo-${campo.slug}`);
                    if (!inputEl?.value?.trim()) {
                        return `Por favor, preencha o campo "${campo.label}"`;
                    }
                    break;
                }
            }
        }

        return null;
    };

    handleConfirmarServico = () => {
        const agendamento = this.state.evento_selecionado?.dados_evento;
        
        // Check if new modal should be used
        const useNewModal = getConfig(
            agendamento?.dados_programa?.configuracoes, 
            'show_modal_confirm_service', 
            false
        );
        
        if (useNewModal) {
            this.setState({
                showConfirmarRealizacaoModal: true,
            });
            return;
        }
        
        // Continue with MySwal if flag is false
        const MySwal = withReactContent(Swal);
        const dataRealizacaoPadrao = moment().tz('America/Sao_Paulo').format('YYYY-MM-DDTHH:mm');
    
        const configuracoesServico = agendamento?.dados_servico_procedimento?.configuracoes;
        const camposDinamicos = configuracoesServico?.modal_confirmacao?.campos || [];
        const temCamposDinamicos = camposDinamicos.length > 0;

        const htmlCamposDinamicos = temCamposDinamicos
            ? `<div class="campos-dinamicos-container mt-3 pt-3 border-top">${this.gerarHtmlCamposDinamicos(camposDinamicos)}</div>`
            : '';

        // Serviço de monitoria: exige o Arquivo de Monitoramento (e valida o PDF VNS quando o programa pede)
        const isMonitoria = agendamento?.dados_servico_procedimento?.servico_dados_monitoramento === true
            || (agendamento?.dados_servico_procedimento?.nome || '').startsWith('Monitoria');
        const validarPdfMonitoramento = isMonitoria && getConfig(agendamento?.dados_programa?.configuracoes, 'agendamento.validar_pdf_monitoramento', false);

        const aceitaMonitoria = validarPdfMonitoramento ? '.pdf' : '.pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png';
        const htmlMonitoria = isMonitoria ? `
                    <label for="swal-input-arquivo-monitoria" class="text-start mt-3">Arquivo de Monitoramento <span class="text-danger">*</span></label>
                    <input id="swal-input-arquivo-monitoria" type="file"
                        accept="${aceitaMonitoria}"
                        class="form-control form-control-sm" style="display: block; width: 100%; margin-top: 0.5rem; font-size: 0.875rem;" />
                    <div id="swal-msg-monitoria" class="text-start small mt-1"></div>
        ` : '';

        MySwal.fire({
            title: 'Confirmar Realização',
            html: `
                <div class="text-start container-confirma-servico" style="max-height: 65vh; overflow-y: auto; overflow-x: hidden; padding-right: 10px;">
                    <p class="text-start">Deseja confirmar a realização de <strong>${agendamento.dados_servico_procedimento.nome}</strong>?</p>

                    <label for="swal-input-data" class="text-start">Data de Realização do Serviço</label>
                    <input id="swal-input-data" type="datetime-local"
                        value="${dataRealizacaoPadrao}"
                        min="${moment().subtract(30, 'days').format('YYYY-MM-DDTHH:mm')}"
                        max="${moment().format('YYYY-MM-DDTHH:mm')}"
                        class="swal2-input swal-input-data" />

                    ${htmlMonitoria}

                    <label for="swal-textarea-anotacoes" class="text-start mt-3">Anotações do Serviço (opcional)</label>
                    <textarea id="swal-textarea-anotacoes" class="swal2-textarea swal-textarea-anotacoes"></textarea>

                    ${htmlCamposDinamicos}
                </div>
            `,
            width: temCamposDinamicos ? '800px' : '650px',
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, confirmar!',
            cancelButtonText: 'Cancelar',
            didOpen: (el) => {
                if (temCamposDinamicos) {
                    this.configurarEventosCamposDinamicos(el, camposDinamicos);
                }

                if (validarPdfMonitoramento) {
                    const confirmBtn = Swal.getConfirmButton();
                    const fileInput = document.getElementById('swal-input-arquivo-monitoria');
                    const msg = document.getElementById('swal-msg-monitoria');

                    const setMsg = (texto, cor) => {
                        if (!msg) return;
                        msg.textContent = texto || '';
                        msg.className = `text-start small mt-1 text-${cor || 'muted'}`;
                    };

                    // enquanto não houver arquivo válido, mantém o envio bloqueado
                    if (confirmBtn) confirmBtn.disabled = true;

                    if (fileInput) {
                        fileInput.addEventListener('change', async () => {
                            if (!fileInput.files || fileInput.files.length === 0) {
                                if (confirmBtn) confirmBtn.disabled = true;
                                setMsg('', 'muted');
                                return;
                            }

                            if (confirmBtn) confirmBtn.disabled = true;
                            setMsg('Validando arquivo...', 'muted');

                            const resultado = await validarPdfMonitoramentoVns(fileInput.files[0]);

                            if (resultado.ok) {
                                setMsg('Arquivo válido.', 'success');
                                if (confirmBtn) confirmBtn.disabled = false;
                            } else {
                                setMsg(resultado.motivo, 'danger');
                                if (confirmBtn) confirmBtn.disabled = true;
                            }
                        });
                    }
                }
            },
            preConfirm: () => {
                const data = document.getElementById('swal-input-data').value;
                const anotacoes = document.getElementById('swal-textarea-anotacoes').value;

                if (!data) {
                    Swal.showValidationMessage('Por favor, selecione uma data de realização');
                    return false;
                }

                let arquivoMonitoria = null;
                if (isMonitoria) {
                    const elArquivo = document.getElementById('swal-input-arquivo-monitoria');
                    if (elArquivo && elArquivo.files && elArquivo.files.length > 0) {
                        arquivoMonitoria = elArquivo.files[0];
                    } else {
                        Swal.showValidationMessage('Por favor, selecione o arquivo de monitoramento');
                        return false;
                    }
                }

                if (temCamposDinamicos) {
                    const erroValidacao = this.validarCamposDinamicos(camposDinamicos);
                    if (erroValidacao) {
                        Swal.showValidationMessage(erroValidacao);
                        return false;
                    }
                }

                const dadosDinamicos = temCamposDinamicos
                    ? this.coletarValoresCamposDinamicos(camposDinamicos)
                    : { valores: {}, arquivos: {} };

                return {
                    data,
                    anotacoes,
                    arquivoMonitoria,
                    dadosConfirmacao: dadosDinamicos.valores,
                    arquivosConfirmacao: dadosDinamicos.arquivos
                };
            }
        }).then((result) => {
            if (result.isConfirmed) {
                // loading enquanto processa (finalizar + relato pode demorar alguns segundos)
                Swal.fire({
                    title: 'Confirmando realização...',
                    allowOutsideClick: false,
                    didOpen: () => Swal.showLoading(),
                });

                const dataRealizacao = moment(result.value.data).tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm:ss');
                const anotacoes = result.value.anotacoes;
                const dadosConfirmacao = result.value.dadosConfirmacao;
                const arquivosConfirmacao = result.value.arquivosConfirmacao;
                const arquivoMonitoria = result.value.arquivoMonitoria;

                const payload = {
                    data_agendamento: agendamento.data_agendamento,
                    data_realizacao: dataRealizacao,
                    tipo: agendamento.dados_servico_procedimento.tipo,
                    adicionar_servico_atendimento: true,
                    servico_procedimento_id: agendamento.servico_procedimento_id,
                    situacao: 'finalizado',
                } 
                if(agendamento.prestador_id){
                    payload['prestador_id'] = agendamento.prestador_id;
                }
                if(agendamento.beneficiario_id){
                    payload['beneficiario_id'] = agendamento.beneficiario_id;
                }
                if(agendamento.atendimento_id){
                    payload['atendimento_id'] = agendamento.atendimento_id;
                }

                if (anotacoes && anotacoes.trim() !== '') {
                    payload.anotacoes = anotacoes;
                }

                 // Array of Objects refactor
                if (temCamposDinamicos && Object.keys(dadosConfirmacao).length > 0) {
                    const dadosConfirmacaoArray = [];
                    camposDinamicos.forEach(campo => {
                        const valor = dadosConfirmacao[campo.slug];
                        if (valor !== undefined && valor !== null && valor !== "") {
                            dadosConfirmacaoArray.push({
                                slug: campo.slug,
                                label: campo.label,
                                value: valor,
                                type: campo.tipo
                            });
                        }
                    });
                    
                    if (dadosConfirmacaoArray.length > 0) {
                        payload.dados_confirmacao = dadosConfirmacaoArray;
                    }
                }
    
                const temArquivos = Object.keys(arquivosConfirmacao).length > 0;
                let requestPromise;

                if (temArquivos) {
                    const formData = new FormData();
                    
                    Object.entries(payload).forEach(([key, value]) => {
                        if (value !== null && value !== undefined) {
                            if (typeof value === 'object' && !(value instanceof File)) {
                                formData.append(key, JSON.stringify(value));
                            } else {
                                formData.append(key, value);
                            }
                        }
                    });

                    Object.entries(arquivosConfirmacao).forEach(([slug, arquivo]) => {
                        formData.append(`arquivo_${slug}`, arquivo);
                    });
                    
                    const arquivosKeys = Object.keys(arquivosConfirmacao);
                    if (arquivosKeys.length > 0) {
                        formData.append('arquivo_confirmacao', arquivosConfirmacao[arquivosKeys[0]]);
                    }

                    requestPromise = api.put(`/agendamentos/${this.state.evento_selecionado.agendamento_id}/`, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    });
                } else {
                    requestPromise = api.put(`/agendamentos/${this.state.evento_selecionado.agendamento_id}/`, payload);
                }

                requestPromise
                    .then(() => {
                        // Serviço de monitoria: envia o arquivo de monitoramento como relato
                        if (isMonitoria && arquivoMonitoria && this.state.evento_selecionado.atendimento_id) {
                            const formDataArquivo = new FormData();
                            formDataArquivo.append('monitoramento_pdf', arquivoMonitoria);
                            formDataArquivo.append('titulo', 'VNS Therapy');
                            formDataArquivo.append('modelo_dados_monitoramento', 'vns_therapy');
                            formDataArquivo.append('servico_dados_monitoramento', true);
                            formDataArquivo.append('atendimento_id', this.state.evento_selecionado.atendimento_id);
                            formDataArquivo.append('tipo', 'etapa');
                            if (agendamento.etapa_atual?.id) {
                                formDataArquivo.append('etapa_id', agendamento.etapa_atual.id);
                            }
                            return api.post('/atendimentos/relatos/', formDataArquivo, {
                                headers: { 'Content-Type': 'multipart/form-data' }
                            });
                        }
                        return Promise.resolve();
                    })
                    .then(() => {
                        if(this.state.evento_selecionado.atendimento_id){
                            // Cadastrar relato após confirmar o agendamento.
                            // O endpoint de relatos aceita apenas multipart/form-data (não JSON).
                            const formDataRelato = new FormData();
                            formDataRelato.append('data', dataRealizacao);
                            if (agendamento.etapa_atual?.id) {
                                formDataRelato.append('etapa_id', agendamento.etapa_atual.id);
                            }
                            formDataRelato.append('atendimento_id', this.state.evento_selecionado.atendimento_id);
                            formDataRelato.append('tipo', 'etapa');
                            formDataRelato.append('titulo', `Realização de ${agendamento.dados_servico_procedimento.nome}`);
                            formDataRelato.append('servico_procedimento_id', this.state.evento_selecionado.servico_procedimento_id);
                            formDataRelato.append('ignorar_cadastro_servico', true);
                            formDataRelato.append('agendamento_id', agendamento.id);
                            return api.post('/atendimentos/relatos/', formDataRelato, {
                                headers: { 'Content-Type': 'multipart/form-data' }
                            });
                        }
                        return Promise.resolve();
                    })
                    .then(() => {
                        MySwal.fire({
                            title: 'Sucesso!',
                            text: 'Realização de serviço confirmado com sucesso.',
                            icon: 'success',
                            confirmButtonColor: '#3085d6',
                        });
                        this.handleCloseModalAgendamento();
                        this.buscaAgendas(false, 1);
                    })
                    .catch((error) => {
                        const errorMessage =
                            error.response && error.response.data
                                ? error.response.data.message || 'Erro ao confirmar o serviço ou registrar o relato.'
                                : 'Erro ao confirmar o serviço ou registrar o relato.';
                        MySwal.fire({
                            title: 'Erro!',
                            text: errorMessage,
                            icon: 'error',
                            confirmButtonColor: '#3085d6',
                        });
                    });
            }
        });
    };

    /**
     * Abre o modal de formulário dinâmico para serviços
     */
    handleEnviaCadastroFormularioDinamico = () => {
        const agendamento = {
            ...this.state.evento_selecionado.dados_evento,
            id: this.state.evento_selecionado.agendamento_id,
            atendimento_id: this.state.evento_selecionado.atendimento_id,
        };

        const temRespostas = agendamento.dados_formulario_dinamico_servicos && Object.keys(agendamento.dados_formulario_dinamico_servicos).length > 0;

        this.setState({
            showModalPersonalizadoServicos: true,
            agendamentoFormularioDinamico: agendamento,
            formularioDinamicoReadOnly: !!temRespostas,
        });
    };

    /**
     * Verifica se deve mostrar o botão de formulário dinâmico para o agendamento
     */
    deveMostrarBotaoFormularioDinamico = () => {
        const dados = this.state.evento_selecionado?.dados_evento;
        if (!dados) return false;
        
        const configFormulario = dados?.dados_servico_procedimento?.configuracoes?.formulario_dinamico_servicos_procedimentos;
        if (!configFormulario) return false;
        
        const showOnEtapa = configFormulario.show_on_etapa;
        const etapaAtualNome = dados?.etapa_atual?.nome;
        
        // Se não tem restrição de etapa, mostra sempre
        if (!showOnEtapa || !Array.isArray(showOnEtapa)) return true;
        
        // Verifica se a etapa atual está na lista de etapas permitidas
        return showOnEtapa.includes(etapaAtualNome);
    };

    /**
     * Retorna o título do botão de formulário dinâmico
     */
    getTituloBotaoFormularioDinamico = () => {
        const dados = this.state.evento_selecionado?.dados_evento;
        const temRespostas = dados?.dados_formulario_dinamico_servicos && Object.keys(dados.dados_formulario_dinamico_servicos).length > 0;
        
        if (temRespostas) return 'Ver Respostas';

        const configFormulario = dados?.dados_servico_procedimento?.configuracoes?.formulario_dinamico_servicos_procedimentos;
        return configFormulario?.titulo_botao || 'Formulário';
    };


    enviaSituacaoAgendamento = (e) => {
        e.preventDefault();

        if (!this.state.evento_selecionado.dados_evento.situacao) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Nenhuma situação selecionada. Por favor, selecione uma situação para continuar.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }

        const MySwal = withReactContent(Swal)

        const data_atual = getDataAtual();

        //vererifica se é edição ou adição
        const url = '/agendamentos/'+this.state.evento_selecionado.agendamento_id+'/'
        const metodo = 'put'

        let data_update = {
            data_agendamento: this.state.evento_selecionado.dados_evento.data_agendamento,
            beneficiario_id: this.state.evento_selecionado.beneficiario_id,
            atendimento_id: this.state.evento_selecionado.atendimento_id,
            tipo: this.state.evento_selecionado.dados_evento.dados_servico_procedimento.tipo,
            //valor: this.state.agendamento_selecionado.valor,
            servico_procedimento_id: this.state.evento_selecionado.dados_evento.servico_procedimento_id,
            situacao: this.state.evento_selecionado.dados_evento.situacao
        } 

        if(this.state.evento_selecionado.dados_evento.prestador_id) {
            data_update['prestador_id'] = this.state.evento_selecionado.dados_evento.prestador_id;
        }

        if(this.state.evento_selecionado.dados_evento.situacao == 'finalizado'){
            data_update.adicionar_servico_atendimento = true;
        }

        if(this.state.evento_selecionado.dados_evento.situacao == 'liberado' && this.state.evento_selecionado.dados_evento.data_liberacao) {
            /*if (!this.state.agendamento_selecionado.data_liberacao) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Atenção!',
                    text: 'Por favor informe a data de liberação.',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Ok'
                });
                return; // Interrompe a execução do método
            }*/

            data_update['data_liberacao'] = this.state.evento_selecionado.dados_evento.data_liberacao
        }

        if (this.state.evento_selecionado.dados_evento.situacao === 'cancelado') {
            // se vier lista de motivos, deve ter opção selecionada
            if (this.state.motivosCancelamento.length > 0 && !this.state.motivoSelecionado) {
              Swal.fire('Atenção', 'Selecione o motivo do cancelamento.', 'warning');
              return;
            }
            // se selecionou “outro”, deve descrever
            if (this.state.motivoSelecionado === 'outro' && !this.state.motivoOutro.trim()) {
              Swal.fire('Atenção', 'Descreva o motivo do cancelamento.', 'warning');
              return;
            }

            if (this.state.motivoSelecionado && this.state.motivoSelecionado !== 'outro') {
                data_update['motivo_id'] = this.state.motivoSelecionado;
            } else {
                data_update['motivo_outro'] = this.state.motivoOutro;
            }
            data_update['data_cancelamento'] = data_atual;
        }

        if(this.state.evento_selecionado.dados_evento.situacao == 'finalizado') {
            if (!this.state.evento_selecionado.dados_evento.data_realizacao) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Atenção!',
                    text: 'Por favor informe a data de realização.',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Ok'
                });
                return; // Interrompe a execução do método
            }

            data_update['data_realizacao'] = this.state.evento_selecionado.dados_evento.data_realizacao
        }

        this.setState({
            loading: true,
        });

        //envia para api
        api({
            method: metodo,
            url: url,
            data: data_update
        })
        .then(response => {
            
            const textSwal = 'Agendamento atualizado com sucesso';

            this.setState({
                loading: false
            });

            // Tudo concluído aqui, agora pode navegar
            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            }).then((result) => {
                //redireciona
                this.handleCloseModalAgendamento();
                this.handleCloseModalAtualizarAgendamento();
                this.buscaAgendas(false, 1);
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao atualizar situação, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];
                };
            }

            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Atenção',
                html: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
            this.handleCloseModalAgendamento();
            this.buscaAgendas(false, 1);

            //Sentry.captureException(erro_msg);
        });
    };

    getCalendarioDatasVisiveis = () => {
        const calendarApi = this.calendarRef?.getApi();
        if (calendarApi) {
            const start = moment(calendarApi.view.activeStart).format('YYYY-MM-DD');
            const end = moment(calendarApi.view.activeEnd).subtract(1, 'days').format('YYYY-MM-DD');
            return { start, end };
        }
        return null;
    }

    handleAceiteAgendamento = async (agendamento, aceite) => {
        const isAceite = !!aceite;
        const acao = aceite ? "Aceitar" : "Recusar";
        
        const swalConfig = {
            title: `${acao} agendamento?`,
            text: `Tem certeza que deseja ${acao.toLowerCase()} o agendamento #${agendamento.id}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: acao,
            cancelButtonText: "Cancelar",
            buttonsStyling: true,
            confirmButtonColor: isAceite ? "#28a745" : "#dc3545",
            cancelButtonColor: "#6c757d",
        };

        // Campo de motivo apenas na recusa
        if (!isAceite) {
            swalConfig.input = "textarea";
            swalConfig.inputPlaceholder = "Motivo da Recusa";
            swalConfig.inputValue = "";
            swalConfig.inputAttributes = { rows: 3 };
        }

        const { isConfirmed, value: observacao } = await Swal.fire(swalConfig);

        if (!isConfirmed) return;

        // loading enquanto processa (a chamada pode demorar alguns segundos)
        Swal.fire({
            title: `${isAceite ? "Aceitando" : "Recusando"} agendamento...`,
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
        });

        try {
            await api.post("/agendamentos/aceite/", {
                agendamento_id: agendamento.id,
                aceite: !!aceite,
                // no aceite (Swal sem input) value vem como boolean; garante string para o backend
                observacao: typeof observacao === "string" ? observacao : "",
            });

            await Swal.fire({
                icon: "success",
                title: `Agendamento ${aceite ? "aceito" : "recusado"} com sucesso!`,
                timer: 1500,
                showConfirmButton: false,
            });

            // atualiza o status no modal aberto (para os botões/badge refletirem na hora)
            const novoStatus = aceite ? "aceito" : "recusado";
            this.setState((prev) => ({
                evento_selecionado: prev.evento_selecionado
                    ? {
                        ...prev.evento_selecionado,
                        dados_evento: {
                            ...prev.evento_selecionado.dados_evento,
                            status_aceite: novoStatus,
                        },
                    }
                    : prev.evento_selecionado,
            }));

            // recarrega os eventos do calendário
            this.buscaAgendas(false, 1);
        } catch (e) {
            Swal.close();
            Swal.fire({
                icon: "error",
                title: "Erro ao processar",
                text:
                    e?.response?.data?.detail ||
                    e?.response?.data?.message ||
                    "Não foi possível concluir a operação.",
            });
        }
    };

    // DESPESAS 
    handleShowDespesasAgendamentos = async (agendamento) => {
        this.setState({
            showModalAgendamento: false,
            showDespesasAgendamentosModal: true,
            despesasAgendamentosLoading: true,
            despesasAgendamentosErro: '',
            despesasAgendamentosRows: [],
            despesasAgendamentosAgendamentoId: agendamento.id,
            despesasAgendamentosShowForm: false,
            despesasAgendamentosForm: { descricao: '', valor: '', data: '', despesa_categoria_id: '', categoria_outros: '', comprovanteFile: null},
            informar_km: false,
            endereco_origem: '',
            endereco_destino: '',
            km_total: '',
            motivo: '',
        });

        try {
            const [catResp, listResp] = await Promise.all([api.get('/agendamentos/despesas/categorias'), api.get('/agendamentos/despesas/', { params: { agendamento_id: agendamento.id } }),]);

            const categorias = Array.isArray(catResp.data)
            ? catResp.data
            : (Array.isArray(catResp.data?.results) ? catResp.data.results : []);

            const payload = listResp.data;
            const rows = Array.isArray(payload)
            ? payload
            : (Array.isArray(payload?.results) ? payload.results : (payload ? [payload] : []));

            this.setState({
                despesasAgendamentosCategorias: categorias,
                despesasAgendamentosRows: rows,
                despesasAgendamentosLoading: false,
            });
        } catch (e) {
            this.setState({
                despesasAgendamentosLoading: false,
                despesasAgendamentosErro:
                e?.response?.data?.detail || e?.message || 'Erro ao carregar despesas.',
            });
        }
    };

    handleCloseDespesasAgendamentos = () => {
        this.setState({
            showDespesasAgendamentosModal: false,
            showModalAgendamento: true,
            despesasAgendamentosLoading: false,
            despesasAgendamentosErro: '',
            despesasAgendamentosRows: [],
            despesasAgendamentosAgendamentoId: null,
            despesasAgendamentosCategorias: [],
            despesasAgendamentosShowForm: false,
            despesasAgendamentosForm: { descricao: '', valor: '', data: '', despesa_categoria_id: '', categoria_outros: '', comprovanteFile: null},
        });
    };

    handleChangeDespesasAgendamentosForm = (e) => {
        const { name, value, files, type } = e.target;

        if (name === 'comprovante') {
            this.setState(s => ({
                despesasAgendamentosForm: { ...s.despesasAgendamentosForm, comprovanteFile: files?.[0] || null }
            }));
        } else {
            this.setState(s => ({
                despesasAgendamentosForm: { ...s.despesasAgendamentosForm, [name]: type === 'number' ? Number(value) : value }
            }));
        }
    };

    carregaCategoriasDespesas = async (inputValue) => {
        try {
            const resp = await api.get('/agendamentos/despesas/categorias', {
                params: { titulo: inputValue || '', search: inputValue || '' }
            });
            const lista = Array.isArray(resp.data) ? resp.data : (resp.data?.results || []);
            const mapped = lista.map(cat => ({
                value: String(cat.id),
                label: cat.titulo,
                slug: cat.slug || ''
            }));
            // acrescenta "Outros" no final
            return [...mapped, { value: '__outros__', label: 'Outros', slug: 'outros' }];
        } catch (err) {
            console.error('Erro ao carregar categorias de despesas:', err);
            return [{ value: '__outros__', label: 'Outros', slug: 'outros' }];
        }
    };


    handleChangeDespesasAgendamentosCategoria = (opt) => {
        const id = opt?.value || '';
        const nome = opt?.label || '';

        this.setState(s => ({
            despesasAgendamentosForm: {
            ...s.despesasAgendamentosForm,
            despesa_categoria_id: id,
            despesa_categoria_nome: nome,       
            // se não for “Outros”, zera o texto
            categoria_outros: nome.toLowerCase() === 'outros' ? s.despesasAgendamentosForm.categoria_outros : '',
            },
        }));
    };

   handleSubmitDespesaAgendamentos = async (e) => {
        e?.preventDefault?.();

        const f = this.state.despesasAgendamentosForm;
        const agendamentoId = this.state.despesasAgendamentosAgendamentoId;

        const catIsOutros =
            (f.despesa_categoria_slug || '').toLowerCase() === 'outros' ||
            (f.despesa_categoria_nome || '').toLowerCase() === 'outros' ||
            String(f.despesa_categoria_id) === '__outros__';

        Swal.fire({
            title: 'Enviando...',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
        });

        try {
            const formData = new FormData();
            formData.append('descricao', f.descricao || '');
            formData.append('agendamento_id', agendamentoId);

            const valorApi = typeof formatarValorAPI === 'function'
                ? formatarValorAPI(f.valor)
                : String(f.valor || '').replace(/\./g, '').replace(',', '.');

            if (valorApi) formData.append('valor', valorApi);
            if (f.data) formData.append('data', f.data);
            if (f.comprovanteFile) formData.append('comprovante', f.comprovanteFile);

            if (catIsOutros) {
                formData.append('categoria_outros', f.categoria_outros || '');
            } else if (f.despesa_categoria_id) {
                formData.append('despesa_categoria_id', f.despesa_categoria_id);
            }

            if (f.informar_km) {
                if (f.endereco_origem) 
                    formData.append('endereco_origem', f.endereco_origem);
                if (f.endereco_destino) 
                    formData.append('endereco_destino', f.endereco_destino);
                if (f.motivo) 
                    formData.append('motivo', f.motivo);

                const kmTotal = String(f.km_total || '').replace(/\./g, '').replace(',', '.');

                if (kmTotal) 
                    formData.append('km_total', kmTotal);
            }

            await api.post('/agendamentos/despesas/', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            Swal.close(); // fecha o loading
            await Swal.fire({
                icon: 'success',
                title: 'Despesa cadastrada com sucesso!',
                timer: 1400,
                showConfirmButton: false,
            });

            // Recarrega a listagem
            this.setState({ despesasAgendamentosLoading: true });
            const listResp = await api.get('/agendamentos/despesas/', {
            params: { agendamento_id: agendamentoId },
            });
            const payload = listResp.data;
            const rows = Array.isArray(payload)
            ? payload
            : (Array.isArray(payload?.results) ? payload.results : (payload ? [payload] : []));

            this.setState({
                despesasAgendamentosRows: rows,
                despesasAgendamentosLoading: false,
                despesasAgendamentosShowForm: false,
                despesasAgendamentosForm: {
                    descricao: '',
                    valor: '',
                    data: '',
                    despesa_categoria_id: '',
                    despesa_categoria_nome: '',
                    despesa_categoria_slug: '',
                    categoria_outros: '',
                    comprovanteFile: null,
                },
            });

            // Atualiza o valor do agendamento somando a despesa adicionada
            const valorDespesaNum = Number(valorApi) || 0;
            if (valorDespesaNum > 0) {
                await this.atualizarValorAgendamentoComDespesa(agendamentoId, valorDespesaNum, 'adicionar');
            }

        } catch (err) {
            Swal.close(); 
            Swal.fire({
            icon: 'error',
            title: 'Erro ao cadastrar despesa',
            text: err?.response?.data?.detail || err?.response?.data?.message || err?.message || 'Verifique os campos e tente novamente.',
            });
        }
    };

    // Método para atualizar o valor do agendamento somando ou subtraindo uma despesa
    atualizarValorAgendamentoComDespesa = async (agendamentoId, valorDespesa, operacao = 'adicionar') => {
        try {
            // Busca o agendamento atual para pegar o valor
            const agendamentoResp = await api.get(`/agendamentos/${agendamentoId}/`);
            const agendamentoAtual = agendamentoResp.data;
            
            // Pega o valor atual do agendamento
            const valorAtual = Number(String(agendamentoAtual.valor || 0).replace(/[^\d.-]+/g, '').replace(',', '.')) || 0;
            
            // Calcula o novo valor baseado na operação
            let novoValor;
            if (operacao === 'adicionar') {
                novoValor = valorAtual + valorDespesa;
            } else {
                novoValor = valorAtual - valorDespesa;
            }
            
            // Garante que o valor não fique negativo
            if (novoValor < 0) novoValor = 0;

            // Atualiza o agendamento via API
            await api.patch(`/agendamentos/${agendamentoId}/`, {
                valor: novoValor
            });

            // Atualiza a lista de agendamentos
            this.buscaAgendas(false, 1);

        } catch (err) {
            console.error('Erro ao atualizar valor do agendamento:', err);
            // Não exibe erro ao usuário pois a despesa já foi salva
        }
    };

    // Método para excluir uma despesa
    handleExcluirDespesa = async (despesaId) => {
        const agendamentoId = this.state.despesasAgendamentosAgendamentoId;
        
        // Encontra a despesa para pegar o valor antes de excluir
        const despesaParaExcluir = this.state.despesasAgendamentosRows.find(d => d.id === despesaId);
        const valorDespesa = despesaParaExcluir 
            ? Number(String(despesaParaExcluir.valor).replace(/[^\d.-]+/g, '').replace(',', '.')) || 0
            : 0;

        const result = await Swal.fire({
            title: 'Confirmar exclusão',
            text: 'Deseja realmente excluir esta despesa?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir',
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) return;

        Swal.fire({
            title: 'Excluindo...',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
        });

        try {
            await api.delete(`/agendamentos/despesas/${despesaId}/`);

            Swal.close();
            await Swal.fire({
                icon: 'success',
                title: 'Despesa excluída com sucesso!',
                timer: 1400,
                showConfirmButton: false,
            });

            // Recarrega a listagem
            this.setState({ despesasAgendamentosLoading: true });
            const listResp = await api.get('/agendamentos/despesas/', {
                params: { agendamento_id: agendamentoId },
            });
            const payload = listResp.data;
            const rows = Array.isArray(payload)
                ? payload
                : (Array.isArray(payload?.results) ? payload.results : (payload ? [payload] : []));

            this.setState({
                despesasAgendamentosRows: rows,
                despesasAgendamentosLoading: false,
            });

            // Atualiza o valor do agendamento subtraindo a despesa excluída
            if (valorDespesa > 0) {
                await this.atualizarValorAgendamentoComDespesa(agendamentoId, valorDespesa, 'remover');
            }

        } catch (err) {
            Swal.close();
            Swal.fire({
                icon: 'error',
                title: 'Erro ao excluir despesa',
                text: err?.response?.data?.detail || err?.response?.data?.message || err?.message || 'Tente novamente.',
            });
        }
    };

    mapAcoesToEvents = (acoes = []) => {
        // cores de ações (ajuste à vontade)
        const corRealizada = '#6f42c1'; // roxo
        const corPendente  = '#17a2b8'; // ciano

        return acoes.map(a => {
            // junta data+hora; se não tiver hora, usa meio-dia só pra cair no dia certo
            const start = `${a.data_acao}T${(a.hora_acao || '12:00:00').slice(0,5)}`;
            const title = `${a.dados_programa_acao?.nome || 'Ação'}: ${a.descricao || ''}`.trim();

            return {
            id: `acao-${a.id}`,
            title,
            start,
            end: start,
            backgroundColor: a.realizado ? corRealizada : corPendente,
            // para diferenciar no click
            source: 'acao',
            dados_acao: a, // fica disponível no extendedProps
            };
        });
    };


    render() {
        if (!hasPerm('view_agendamentos')) {
            return <Navigate to='/sem-permissao' />
        }

        const dados_usuario = getCurrentUser();
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Agendas</h4>
                    </Col>
                    {this.state.dados_usuario['tipo_usuario'] != 'prestador' && this.state.dados_usuario['tipo_usuario'] != 'beneficiario' && (
                        <></>
                    )}
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <Row>
                            <FullCalendar
                                plugins={[ dayGridPlugin, interactionPlugin, listPlugin ]}
                                initialView="dayGridMonth"
                                headerToolbar={{
                                    left: 'customPrev,customNext today',
                                    center: 'title',
                                    right: 'dayGridMonth,dayGridWeek,dayGridDay,listMonth'
                                }}
                                customButtons={{
                                    customPrev: {
                                        text: '<',
                                        click: () => {
                                            const calendarApi = this.calendarRef.getApi();
                                            calendarApi.prev();
                                        },
                                    },
                                    customNext: {
                                        text: '>',
                                        click: () => {
                                            const calendarApi = this.calendarRef.getApi();
                                            calendarApi.next();
                                        },
                                    },
                                }}
                                ref={(calendar) => (this.calendarRef = calendar)}
                                locale={ptLocale} // Define o idioma para português
                                dateClick={this.handleDateClick}
                                eventClick={this.handleEventClick}
                                events={this.state.agendamentos}
                                height="auto"
                                datesSet={(arg) => {
                                    const startOfView = moment(arg.start).format('YYYY-MM-DD');
                                    const endOfView = moment(arg.end).subtract(1, 'days').format('YYYY-MM-DD'); // FullCalendar inclui o primeiro dia do próximo mês

                                    this.setState({
                                        filtro_data_inicio: startOfView,
                                        filtro_data_fim: endOfView,
                                        loading: true
                                    }, () => {
                                        this.buscaAgendas(false, 1);
                                    });
                                }}
                            />
                        </Row>    
                    </Card.Body>                
                </Card>
                {this.state.evento_selecionado.agendamento_id && (
                    <>
                    <Modal show={this.state.showModalAgendamento} onHide={this.handleCloseModalAgendamento} size="lg" enforceFocus={false}>
                        <Modal.Header closeButton>
                            <Modal.Title>Dados do Agendamento (ID: {this.state.evento_selecionado.agendamento_id})</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                        
                        {(dados_usuario['tipo_usuario'] === 'operador' || dados_usuario['is_superuser']) && this.state.evento_selecionado.dados_evento.situacao != 'finalizado' && this.state.evento_selecionado.dados_evento.situacao != 'cancelado' && (
                            <div className="text-right mb-3">
                                <Button variant="warning" size="sm" onClick={() => this.handleShowModalAtualizarAgendamento()}>
                                    Editar Agendamento
                                </Button>
                            </div>
                        )}
                        <Form>
                            <Card className="cardDestaque">
                                <Card.Body>    
                                    <Row>
                                        <h4>{formataDataHoraExibicao(this.state.evento_selecionado.dados_evento.data_agendamento)}
                                            <Button variant={situacaoAgendamento.find(situacao => situacao.value === this.state.evento_selecionado.dados_evento.situacao)?.color} size="sm" className="ms-2" style={{padding: '3px 5px'}}>
                                                {situacaoAgendamento.find(situacao => situacao.value === this.state.evento_selecionado.dados_evento.situacao)?.label}
                                            </Button>
                                        </h4>
                                        <Col sm={12} xs={12}>
                                            <label>Procedimento: </label>
                                            <span> {this.state.evento_selecionado.dados_evento.dados_servico_procedimento.nome}</span>
                                        </Col>  
                                        {this.state.evento_selecionado.dados_evento.data_agendamento && (
                                        <Col sm={6} xs={12}>
                                            <label>Solicitado em: </label>
                                            <span> {formataDataHoraExibicao(this.state.evento_selecionado.dados_evento.data_agendamento) || 'Não solicitado'}</span>    
                                        </Col>
                                        )}
                                        {this.state.evento_selecionado.dados_evento.data_liberacao && (
                                        <Col sm={6} xs={12}>
                                            <label>Liberado em: </label>
                                            <span> {formataDataHoraExibicao(this.state.evento_selecionado.dados_evento.data_liberacao) || 'Não liberado'}</span>    
                                        </Col>
                                        )}
                                        {this.state.evento_selecionado.dados_evento.data_cancelamento && (
                                        <Col sm={6} xs={12}>
                                            <label>Cancelado em: </label>
                                            <span> {formataDataHoraExibicao(this.state.evento_selecionado.dados_evento.data_cancelamento) || 'Não realizado'}</span>
                                        </Col>
                                        )}
                                        <Col sm={6} xs={12}>
                                            <label>Realizado em: </label>
                                            <span> {formataDataHoraExibicao(this.state.evento_selecionado.dados_evento.data_realizacao) || 'Não realizado'}</span>
                                        </Col> 
                                        <Col sm={6} xs={12}>
                                            <a href={'/atendimentos/edit/'+this.state.evento_selecionado.dados_evento.dados_atendimento.uuid} target="_blank" rel="noopener noreferrer">Ver atendimento relacionado</a>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>

                            {this.state.evento_selecionado.dados_evento.situacao !== "cancelado" && this.state.evento_selecionado.dados_evento.envia_aceite === true && (
                                <Card className="cardDestaque">
                                    <Card.Body>
                                        <Row>
                                            <h4>Situação do Aceite</h4>
                                            <div className="mt-1 mb-2">
                                                <span className={`badge-aceite badge-aceite-${(this.state.evento_selecionado.dados_evento.status_aceite || 'aguardando').toLowerCase()}`} title="Status do aceite/recusa">
                                                    {(this.state.evento_selecionado.dados_evento.status_aceite || 'aguardando')
                                                        .replace(/^./, c => c.toUpperCase())}
                                                </span>
                                            </div>
                                            <Col sm={12} xs={12}>
                                                {this.state.evento_selecionado.dados_evento.status_aceite === 'aguardando' && (
                                                        <Button as="button" variant="success" size="sm" className="me-2" onClick={() => this.handleAceiteAgendamento(this.state.evento_selecionado.dados_evento, true)}><FaCheck className="me-2" /> Aceitar Agendamento</Button>
                                                )}
                                                {!["finalizado", "cancelado"].includes(this.state.evento_selecionado.dados_evento.situacao) && this.state.evento_selecionado.dados_evento.status_aceite !== 'recusado' && (
                                                        <Button as="button" variant="danger" size="sm" onClick={() => this.handleAceiteAgendamento(this.state.evento_selecionado.dados_evento, false)}><FaTimes className="me-2" /> Recusar Agendamento</Button>
                                                )}

                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            )}

                            {this.state.evento_selecionado.dados_evento.local_endereco && (
                                <Card className="cardDestaque">
                                    <Card.Body>
                                        <Row>
                                            <h4>Local de Realização</h4>
                                            <Col sm={6} xs={12}>
                                                <label>Nome: </label>
                                                <span> {this.state.evento_selecionado.dados_evento.local_nome || '-'}</span>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <label>CEP: </label>
                                                <span> {this.state.evento_selecionado.dados_evento.local_cep || '-'}</span>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <label>Endereço: </label>
                                                <span> {this.state.evento_selecionado.dados_evento.local_endereco || '-'}</span>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <label>Número: </label>
                                                <span> {this.state.evento_selecionado.dados_evento.local_numero || '-'}</span>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <label>Complemento: </label>
                                                <span> {this.state.evento_selecionado.dados_evento.local_complemento || '-'}</span>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <label>Cidade/UF: </label>
                                                <span> {this.state.evento_selecionado.dados_evento.local_cidade || '-'}/{this.state.evento_selecionado.dados_evento.local_uf || '-'}</span>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <label>Bairro: </label>
                                                <span> {this.state.evento_selecionado.dados_evento.local_bairro || '-'}</span>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            )}

                            <Card className="cardDestaque">
                                <Card.Body>
                                    <Row>
                                        <h4>Dados do Beneficiário</h4>
                                        <Col sm={6} xs={12}>
                                            <label>Nome: </label>
                                            <span> {this.state.evento_selecionado.dados_beneficiario.nome}</span>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <label>CPF: </label>
                                            <span> {formataCPF(this.state.evento_selecionado.dados_beneficiario.cpf)}</span>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <label>Data de Nascimento: </label>
                                            <span> {formataDataExibicao(this.state.evento_selecionado.dados_beneficiario.data_nascimento)}</span>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <label>Idade: </label>
                                            <span> {calcularIdade(this.state.evento_selecionado.dados_beneficiario.data_nascimento)} anos</span>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <label>E-mail: </label>
                                            <span> {this.state.evento_selecionado.dados_beneficiario.email}</span>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <label>Telefone: </label>
                                            <span> {this.state.evento_selecionado.dados_beneficiario.telefone}</span>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <label>Endereço: </label>
                                            <span> {this.state.evento_selecionado.dados_beneficiario.endereco + ' ' + this.state.evento_selecionado.dados_beneficiario.numero + ' ' + (this.state.evento_selecionado.dados_beneficiario.complemento ? this.state.evento_selecionado.dados_beneficiario.complemento + ' ' : '') + this.state.evento_selecionado.dados_beneficiario.bairro}</span>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <label>Cidade/UF: </label>
                                            <span> {this.state.evento_selecionado.dados_beneficiario.cidade + '/' + this.state.evento_selecionado.dados_beneficiario.uf}</span>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>

                            {this.state.evento_selecionado.prestador_id && (
                            <Card className="cardDestaque">
                                <Card.Body>
                                    <Row>
                                        <h4>Dados do Provedor</h4>
                                        <Col sm={6} xs={12}>
                                            <label>Razão Social: </label>
                                            <span> {this.state.evento_selecionado.dados_prestador?.razao_social || 'Não informado'}</span>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <label>Nome Fantasia: </label>
                                            <span> {this.state.evento_selecionado.dados_prestador?.nome_fantasia || 'Não informado'}</span>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <label>CNPJ: </label>
                                            <span> {formataCNPJ(this.state.evento_selecionado.dados_prestador?.cpf_cnpj || 'Não informado')}</span>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <label>Telefone: </label>
                                            <span> {this.state.evento_selecionado.dados_prestador?.telefone || 'Não informado'}</span>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <label>Email: </label>
                                            <span> {this.state.evento_selecionado.dados_prestador?.email || 'Não informado'}</span>
                                        </Col>                                       
                                        <Col sm={6} xs={12}>
                                            <label>Endereço: </label>
                                            <span> {this.state.evento_selecionado.dados_prestador?.endereco + ' ' + this.state.evento_selecionado.dados_prestador?.numero + ' ' + (this.state.evento_selecionado.dados_prestador?.complemento ? this.state.evento_selecionado.dados_prestador?.complemento + ' ' : '') + this.state.evento_selecionado.dados_prestador?.bairro}</span>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <label>Cidade/UF: </label>
                                            <span> {this.state.evento_selecionado.dados_prestador?.cidade + '/' + this.state.evento_selecionado.dados_prestador?.uf}</span>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                            )}

                            
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        {(dados_usuario['tipo_usuario'] === 'prestador' || dados_usuario['tipo_usuario'] === 'beneficiario' || dados_usuario['is_superuser']) && this.state.evento_selecionado.dados_evento.situacao != 'finalizado' && this.state.evento_selecionado.dados_evento.situacao != 'cancelado' && this.state.evento_selecionado.dados_evento.dados_meeting?.whereby_sala_id && this.state.evento_selecionado.dados_evento.dados_meeting?.whereby_sala_url && (
                            <Button variant="secondary" className="btn-sm" href={"/meetings/view/"+this.state.evento_selecionado.agendamento_id} size="sm">
                                Vídeo Conferência
                            </Button>    
                        )}
                        {((this.state.evento_selecionado.dados_evento.situacao !== "finalizado" && this.state.evento_selecionado.dados_evento.situacao !== "cancelado" && (this.state.evento_selecionado.dados_evento.status_aceite === "aceito" || !this.state.evento_selecionado.dados_evento.envia_aceite))) && (
                            <Button variant="success" size="sm" className="me-2 mb-1 mt-1" onClick={() => this.handleConfirmarServico()}>
                                    Confirmar Realização do Serviço
                            </Button>
                        )}
                        {/* Botão de Formulário Dinâmico */}
                        {this.deveMostrarBotaoFormularioDinamico() && this.state.evento_selecionado.dados_evento?.situacao !== 'finalizado' && this.state.evento_selecionado.dados_evento?.situacao !== 'cancelado' && (
                            <Button variant="info" size="sm" className="me-2 mb-1 mt-1 text-white" onClick={() => this.handleEnviaCadastroFormularioDinamico()}>
                                <i className="fa fa-list-alt me-1"></i>
                                {this.getTituloBotaoFormularioDinamico()}
                            </Button>
                        )}
                        {this.state.evento_selecionado.dados_evento.situacao !== "cancelado" && ((this.state.evento_selecionado.dados_evento.envia_aceite === true && this.state.evento_selecionado.dados_evento.status_aceite === "aceito") || !this.state.evento_selecionado.dados_evento.envia_aceite) && (
                            <Button variant="secondary" size="sm" onClick={() => this.handleShowDespesasAgendamentos(this.state.evento_selecionado.dados_evento)}><FaReceipt className="me-2" /> Despesas</Button>
                        )}
                        {/* Botão de Análise de Arquivos (se pendente e permissão ok) */}
                        {this.state.evento_selecionado.dados_evento.situacao === 'arquivo_pendente' && (() => {
                            const evt = this.state.evento_selecionado.dados_evento;
                            const configValidacao = getConfig(evt.dados_programa?.configuracoes || evt.dados_atendimento?.programa?.configuracoes, 'agendamento.validacao_arquivos', false);
                            // Operador/Gestor (sempre) ou Prestador (com config)
                            const user = getCurrentUser();
                            const podeAnalisar = ['operador', 'gestor', ''].includes(user.tipo_usuario) || (user.tipo_usuario === 'prestador' && configValidacao && user.prestador_categoria === 'laboratorio_diagnostico');
                            
                            return podeAnalisar && (
                                <Button variant="warning" size="sm" className="me-2 mb-1 mt-1 text-dark" onClick={() => this.handleShowModalArquivos()}>
                                    <FaFile /> Analisar Arquivos
                                </Button>
                            );
                        })()}
                        
                        {/* Botão Padrão de Arquivos (se NÃO for análise pendente ou se não tiver config) */}
                        {dados_usuario['tipo_usuario'] !== 'prestador' && this.state.evento_selecionado.dados_evento.situacao !== "cancelado" && this.state.evento_selecionado.dados_evento.situacao !== "arquivo_pendente" && ((this.state.evento_selecionado.dados_evento.envia_aceite === true && this.state.evento_selecionado.dados_evento.status_aceite === "aceito") || !this.state.evento_selecionado.dados_evento.envia_aceite) && ( 
                            <Button variant="primary" size="sm" onClick={() => this.handleShowModalArquivos()}>
                                Arquivos
                            </Button>
                        )}
                        <Button variant="secondary-outline" size="sm" onClick={this.handleCloseModalAgendamento}>
                            Fechar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.showDespesasAgendamentosModal} onHide={this.handleCloseDespesasAgendamentos} size="xl" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Despesas do Agendamento</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        {this.state.despesasAgendamentosLoading && <div className="text-muted">Carregando…</div>}

                        {!this.state.despesasAgendamentosLoading && this.state.despesasAgendamentosErro && (
                        <div className="text-danger">{this.state.despesasAgendamentosErro}</div>
                        )}

                        {!this.state.despesasAgendamentosLoading && !this.state.despesasAgendamentosErro && (
                        this.state.despesasAgendamentosRows.length > 0 ? (
                            <>
                            <Table responsive className="custom-table table-sm align-middle mb-2">
                                <thead>
                                    <tr>
                                        <th>Descrição</th>
                                        <th>Data</th>
                                        <th>Categoria</th>
                                        <th>Prestador</th>
                                        <th>Valor</th>
                                        <th>Comprovante</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.despesasAgendamentosRows.map((d) => {
                                        const catLabel = d.categoria_outros
                                            ? `Outros: ${d.categoria_outros}`
                                            : (d.dados_categoria?.nome || '-');

                                        const valorLabel = (() => {
                                            // tenta formatar pt-BR
                                            const num = Number(String(d.valor).replace(/[^\d.-]+/g, '').replace(',', '.'));
                                            if (!isNaN(num)) return num.toLocaleString('pt-BR',{style:'currency',currency:'BRL'});
                                            return d.valor ?? '-';
                                        })();

                                        return (
                                            <tr key={d.id}>
                                                <td data-label="Descrição">{d.descricao || '-'}</td>
                                                <td data-label="Data">{d.data ? new Date(d.data).toLocaleDateString('pt-BR') : '-'}</td>
                                                <td data-label="Categoria">{catLabel}</td>
                                                <td data-label="Prestador">{d.dados_prestador?.nome}</td>
                                                <td data-label="Valor">{valorLabel}</td>
                                                <td data-label="Comprovante">
                                                    {d.comprovante
                                                    ? <a href={d.comprovante} target="_blank" rel="noreferrer">Abrir</a>
                                                    : '-'}
                                                </td>
                                                <td data-label="Ações">
                                                    <Button
                                                        variant="outline-danger"
                                                        size="sm"
                                                        onClick={() => this.handleExcluirDespesa(d.id)}
                                                        title="Excluir despesa"
                                                    >
                                                        <FaTrash />
                                                    </Button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                            <div className="d-flex justify-content-between fw-bold px-1 mb-2 border-top pt-2">
                                <span>Total</span>
                                <span>
                                {(() => {
                                    const total = this.state.despesasAgendamentosRows.reduce((acc, d) => {
                                    const num = Number(String(d.valor).replace(/[^\d.-]+/g, '').replace(',', '.'));
                                    return acc + (isNaN(num) ? 0 : num);
                                    }, 0);
                                    return total.toLocaleString('pt-BR',{style:'currency',currency:'BRL'});
                                })()}
                                </span>
                            </div>
                            </>
                        ) : (
                            <div className="text-muted">Nenhuma despesa cadastrada.</div>
                        )
                        )}

                        <hr className="my-3" />

                        <div className="d-flex justify-content-end">
                            <Button
                                variant={this.state.despesasAgendamentosShowForm ? "outline-secondary" : "primary"}
                                size="sm"
                                onClick={() => this.setState(s => ({ despesasAgendamentosShowForm: !s.despesasAgendamentosShowForm }))}
                            >
                                {this.state.despesasAgendamentosShowForm ? (
                                    <>
                                        Cancelar Nova Despesa
                                    </>
                                ) : (
                                    <>
                                        <FaPlus className="me-1" /> Nova Despesa
                                    </>
                                )}
                            </Button>
                        </div>

                        {/* Formulário de nova despesa */}
                        {this.state.despesasAgendamentosShowForm && (
                            <Form className="mt-3" onSubmit={this.handleSubmitDespesaAgendamentos}>
                                <Row className="g-3">
                                    <Col md={6}>
                                        <Form.Group controlId="despesaDescricao">
                                        <Form.Label>Descrição</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="descricao"
                                            value={this.state.despesasAgendamentosForm.descricao}
                                            onChange={this.handleChangeDespesasAgendamentosForm}
                                            required
                                        />
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group controlId="despesaValor">
                                            <Form.Label>Valor</Form.Label>
                                            <NumericFormat
                                                name="valor"
                                                thousandSeparator={'.'}
                                                decimalSeparator={','}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                prefix={'R$ '}
                                                value={this.state.despesasAgendamentosForm.valor}
                                                onChange={this.handleChangeDespesasAgendamentosForm}
                                                className="form-control"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group controlId="despesaData">
                                            <Form.Label>Data</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="data"
                                                value={this.state.despesasAgendamentosForm.data}
                                                onChange={this.handleChangeDespesasAgendamentosForm}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group controlId="despesaCategoria">
                                            <Form.Label>Categoria</Form.Label>
                                            <AsyncSelect
                                                cacheOptions
                                                defaultOptions={[...(this.state.despesasAgendamentosCategorias || []).map(c => ({value: String(c.id), label: c.titulo, slug: c.slug || ''})),{ value: '__outros__', label: 'Outros', slug: 'outros' },]}
                                                loadOptions={this.carregaCategoriasDespesas}
                                                name="despesa_categoria_id"
                                                placeholder="Buscar categoria..."
                                                noOptionsMessage={() => "Nenhuma categoria encontrada"}
                                                isClearable
                                                onChange={(opt) => this.setState(s => ({
                                                despesasAgendamentosForm: {
                                                    ...s.despesasAgendamentosForm,
                                                    despesa_categoria_id: (opt?.slug === 'outros') ? '' : (opt?.value || ''),
                                                    despesa_categoria_nome: opt?.label || '',
                                                    despesa_categoria_slug: opt?.slug || '',
                                                    categoria_outros: (opt?.slug === 'outros')
                                                    ? s.despesasAgendamentosForm.categoria_outros
                                                    : '',
                                                    // Quilometragem já abre os campos de km automaticamente
                                                    informar_km: opt?.slug === 'quilometragem',
                                                }
                                                }))}
                                                value={(() => {const f = this.state.despesasAgendamentosForm; if ((f.despesa_categoria_slug || '').toLowerCase() === 'outros') { return { value: '__outros__', label: 'Outros', slug: 'outros' };}
                                                    return f.despesa_categoria_id
                                                        ? { value: String(f.despesa_categoria_id), label: f.despesa_categoria_nome || 'Selecionada' }
                                                        : null;
                                                    })()}
                                                menuPortalTarget={document.body}
                                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                            />

                                            <Collapse
                                                in={(this.state.despesasAgendamentosForm.despesa_categoria_slug || '').toLowerCase() === 'outros'}
                                                mountOnEnter
                                                unmountOnExit
                                            >
                                                <div>
                                                <Form.Group controlId="despesaCategoriaOutros" className="mt-2">
                                                    <Form.Label>Descrever (Outros)</Form.Label>
                                                    <Form.Control
                                                    type="text"
                                                    name="categoria_outros"
                                                    value={this.state.despesasAgendamentosForm.categoria_outros}
                                                    onChange={this.handleChangeDespesasAgendamentosForm}
                                                    required
                                                    />
                                                </Form.Group>
                                                </div>
                                            </Collapse>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group controlId="despesaComprovante">
                                        <Form.Label>Comprovante (imagem ou PDF)</Form.Label>
                                        <Form.Control
                                            type="file"
                                            name="comprovante"
                                            accept="image/*,.pdf"
                                            onChange={this.handleChangeDespesasAgendamentosForm}
                                        />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                {/* Informar km — oculto quando a categoria é Quilometragem (já implícito) */}
                                {(this.state.despesasAgendamentosForm.despesa_categoria_slug || '').toLowerCase() !== 'quilometragem' && (
                                <Form.Group className="mt-3" controlId="despesaInformarKm">
                                <Form.Label className="me-3">Informar km</Form.Label>
                                    <Form.Check
                                        inline
                                        type="radio"
                                        id="informarKmNao"
                                        label="Não"
                                        name="informar_km_choice"
                                        checked={!this.state.despesasAgendamentosForm.informar_km}
                                        onChange={() => this.setState(s => ({
                                        despesasAgendamentosForm: { ...s.despesasAgendamentosForm, informar_km: false }
                                        }))}
                                    />
                                    <Form.Check
                                        inline
                                        type="radio"
                                        id="informarKmSim"
                                        label="Sim"
                                        name="informar_km_choice"
                                        checked={this.state.despesasAgendamentosForm.informar_km}
                                        onChange={() => this.setState(s => ({
                                        despesasAgendamentosForm: { ...s.despesasAgendamentosForm, informar_km: true }
                                        }))}
                                    />
                                </Form.Group>
                                )}

                                <Collapse in={this.state.despesasAgendamentosForm.informar_km} mountOnEnter unmountOnExit>
                                    <div>
                                        <Row className="g-3 mt-1">
                                            <Col md={6}>
                                                <Form.Group controlId="enderecoOrigem">
                                                <Form.Label>Endereço de origem</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="endereco_origem"
                                                        value={this.state.despesasAgendamentosForm.endereco_origem}
                                                        onChange={this.handleChangeDespesasAgendamentosForm}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group controlId="enderecoOrigem">
                                                <Form.Label>Endereço de Destino</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="endereco_destino"
                                                        value={this.state.despesasAgendamentosForm.endereco_destino}
                                                        onChange={this.handleChangeDespesasAgendamentosForm}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={4}>
                                                <Form.Group controlId="kmTotal">
                                                <Form.Label>Km total</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="0,00"
                                                        name="km_total"
                                                        value={this.state.despesasAgendamentosForm.km_total}
                                                        onChange={this.handleChangeDespesasAgendamentosForm}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={8}>
                                                <Form.Group controlId="kmMotivo">
                                                <Form.Label>Motivo do deslocamento</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={2}
                                                        name="motivo"
                                                        value={this.state.despesasAgendamentosForm.motivo}
                                                        onChange={this.handleChangeDespesasAgendamentosForm}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>
                                </Collapse>

                                <div className="d-flex justify-content-end mt-3">
                                    <Button type="submit" variant="success" size="sm"><FaCheck className="me-1" /> Adicionar Despesa</Button>
                                </div>
                            </Form>
                            )}
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="outline-secondary" onClick={this.handleCloseDespesasAgendamentos}>
                            Fechar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal size="lg" show={this.state.showModalArquivosEdit} onHide={this.handleCloseModalArquivosEdit}>
                    <Modal.Header closeButton>
                        <Modal.Title>Arquivo do Agendamento</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={this.saveArquivo}>
                            <Row>
                                {!this.state.arquivo_id && (
                                    <Col sm={12} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Anexe abaixo um novo arquivo a este agendamento</Form.Label>
                                            <Form.Control type="file" name="arquivo_upload" onChange={this.onChangeArquivo} ref={this.fileInput} />
                                            <Form.Text id="formArquivoHelper" className="text-danger">{this.state.arquivoHelper}</Form.Text>
                                        </Form.Group>
                                    </Col>
                                )}
                                <>
                                    <Col sm={5} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Descrição do Arquivo</Form.Label>
                                            <Form.Control type="text" name="arquivo_nome" value={this.state.arquivo_nome} placeholder="Descrição do arquivo" onChange={e => this.handleChange(e, 'arquivo_nome')} />    
                                        </Form.Group>
                                    </Col>
                                    <Col sm={4} xs={6}> 
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tipo do Arquivo</Form.Label>
                                            <Form.Control as="select" name="arquivo_tipo" value={this.state.arquivo_tipo} required onChange={e => this.handleChange(e, 'arquivo_tipo')}>
                                                <option value="">Selecione um tipo</option>
                                                {Object.entries(tiposArquivos).map(([sigla, nome]) => {
                                                    // Se 'prestador_id' existe, exibe apenas 'laudo' e 'exame'
                                                    if (dados_usuario['prestador_id']) {
                                                        if (sigla === "laudo" || sigla === "exame") {
                                                            return <option key={sigla} value={sigla}>{nome}</option>;
                                                        }
                                                    } else {
                                                        // Se não existe 'prestador_id', exibe todas as opções
                                                        return <option key={sigla} value={sigla}>{nome}</option>;
                                                    }

                                                    // Caso não atenda a nenhum dos casos, retorna null
                                                    return null;
                                                })}
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                    {!dados_usuario['prestador_id'] && (
                                        <Col sm={3} xs={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Aprovado</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.arquivo_aprovado ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ arquivo_aprovado: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.arquivo_aprovado ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ arquivo_aprovado: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    )}
                                </> 
                                <Col sm={12} xs={12}>
                                    <Button type="submit" variant="secondary">
                                        {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : (this.state.arquivo_id) ? 'Atualizar Arquivo' : 'Enviar Arquivo'}      
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary-outline" onClick={this.handleCloseModalArquivosEdit}>
                            Fechar
                        </Button>
                        
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.showModalAtualizarAgendamento} onHide={this.handleCloseModalAtualizarAgendamento}>
                            <Modal.Header closeButton>
                                <Modal.Title>Atualizar Agendamento</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Row>
                                    <Col sm={12} xs={12} className="mb-1">
                                        <div className="row-list">
                                            <Form.Label className="mb-0">
                                                DADOS DO AGENDAMENTO
                                            </Form.Label>
                                            <hr className="mb-2 mt-1"></hr>
                                            <p className="mb-1">
                                                <small>SERVIÇO:</small> <strong>{this.state.evento_selecionado?.dados_evento?.dados_servico_procedimento?.nome}</strong>
                                            </p>
                                            <p className="mb-1">
                                                <small>PRESTADOR:</small> <strong>{this.state.evento_selecionado?.dados_evento?.dados_prestador?.nome}</strong>
                                            </p>
                                            <p className="mb-1">
                                                <small>PACIENTE:</small> <strong>{this.state.evento_selecionado?.dados_beneficiario?.nome}</strong>&nbsp;&nbsp;
                                            </p>
                                            {this.state.evento_selecionado?.dados_beneficiario?.celular && (
                                                <p>
                                                    <small>TELEFONE PACIENTE:</small> <strong>{this.state.evento_selecionado?.dados_beneficiario?.celular || '-'}</strong>
                                                </p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col sm={12} xs={12}> 
                                        <Form.Group className="mb-3">
                                            <Form.Label>Data de Agendamento</Form.Label>
                                            <Form.Control type="datetime-local" name="data_agendamento" required placeholder="Data de Agendamento" value={(this.state.evento_selecionado?.dados_evento?.data_agendamento != '1900-01-01T00:00:00') ? this.state.evento_selecionado?.dados_evento?.data_agendamento : ''} onChange={e => this.handleChangeAgendamentoEdit(e, 'data_agendamento')} />    
                                        </Form.Group>
                                    </Col>
                                    {(dados_usuario['tipo_usuario'] === '' || dados_usuario['tipo_usuario'] === 'operador') && (
                                    <Col sm={12} xs={12}> 
                                        <Form.Group className="mb-3">
                                            <Form.Label>Status</Form.Label>
                                            <Form.Control as="select" name="agendamento_situacao" value={this.state.evento_selecionado?.dados_evento?.situacao} required onChange={this.handleSituacaoChange}>
                                                <option value="">Status</option>
                                                {Object.entries(situacoesAgendamento)
                                                    .filter(([sigla, nome]) => sigla !== "finalizado") // Ignora o status "finalizado" - usado com o botão Confirmar realização do atendimento
                                                    .map(([sigla, nome]) => (
                                                        <option key={sigla} value={sigla}>{nome}</option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                    )}
                                    {this.state.evento_selecionado?.dados_evento?.situacao === 'cancelado' && (
                                        <>
                                            {this.state.motivosCancelamento.length > 0 ? (
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Motivo do cancelamento</Form.Label>
                                                    <Form.Control
                                                    as="select"
                                                    required
                                                    value={this.state.motivoSelecionado}
                                                    onChange={this.handleMotivoChange}
                                                    >
                                                    <option value="">Selecione...</option>
                                                    {this.state.motivosCancelamento.map(m => (
                                                        <option key={m.id} value={m.id}>{m.titulo}</option>
                                                    ))}
                                                    <option value="outro">Outro</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            ) : null}

                                            {(
                                                this.state.motivosCancelamento.length === 0 ||
                                                this.state.motivoSelecionado === 'outro'
                                            ) && (
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Descreva o motivo</Form.Label>
                                                    <Form.Control
                                                    as="textarea"
                                                    rows={2}
                                                    required
                                                    value={this.state.motivoOutro}
                                                    onChange={this.handleMotivoOutroChange}
                                                    />
                                                </Form.Group>
                                            )}
                                        </>
                                    )}
                                    {/*this.state.agendamento_selecionado.situacao == 'liberado' && (
                                        <Col sm={12} xs={12}> 
                                            <Form.Group className="mb-3">
                                                <Form.Label>Data da Liberação</Form.Label>
                                                <Form.Control type="datetime-local" name="agendamento_data_liberacao" required placeholder="Data da Liberação" value={this.state.agendamento_selecionado.data_liberacao} onChange={e => this.handleChangeAgendamentoEdit(e, 'data_liberacao')} />    
                                            </Form.Group>
                                        </Col>
                                    )*/}
                                    {this.state.evento_selecionado.dados_evento.situacao == 'finalizado' && (
                                    <Col sm={12} xs={12}> 
                                        <Form.Group className="mb-3">
                                            <Form.Label>Data da Realização</Form.Label>
                                            <Form.Control type="datetime-local" name="agendamento_data_realizacao" required placeholder="Data da Liberação" value={this.state.evento_selecionado.dados_evento.data_realizacao} onChange={e => this.handleChangeAgendamentoEdit(e, 'data_realizacao')} />    
                                        </Form.Group>
                                    </Col>
                                    )}
                                </Row>  
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary-outline" onClick={this.handleCloseModalAtualizarAgendamento}>
                                    Fechar
                                </Button>
                                <Button variant="secondary" onClick={this.enviaSituacaoAgendamento}>
                                    {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Atualizar'}      
                                </Button>
                            </Modal.Footer>
                        </Modal>

                <Modal size="xl" show={this.state.showModalArquivos} onHide={this.handleCloseModalArquivos}>
                    <Modal.Header closeButton>
                        <Modal.Title>Arquivos do Agendamento</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col sm={12}>
                                <div className="row-list">
                                    <Form.Label className="mb-0">
                                        DADOS DO AGENDAMENTO
                                    </Form.Label>
                                    <hr className="mb-2 mt-1"></hr>
                                    <p className="mb-1">
                                        <small>SERVIÇO:</small> <strong>{this.state.evento_selecionado?.dados_evento?.dados_servico_procedimento?.nome}</strong>
                                    </p>
                                    <p className="mb-1">
                                        <small>PRESTADOR:</small> <strong>{this.state.evento_selecionado?.dados_evento?.dados_prestador?.nome}</strong>
                                    </p>
                                    <p className="mb-1">
                                        <small>PACIENTE:</small> <strong>{this.state.evento_selecionado.dados_beneficiario.nome + ' (Id: '+this.state.evento_selecionado.beneficiario_id+')'}</strong>
                                    </p>
                                    {this.state.evento_selecionado.dados_beneficiario.celular && (
                                        <p>
                                            <small>TELEFONE PACIENTE:</small> <strong>{this.state.evento_selecionado.dados_beneficiario.celular || '-'}</strong>
                                        </p>
                                    )}
                                </div>
                            </Col>
                        </Row>
                        {this.state.arquivos.length > 0 ? (
                            (() => {
                                const eventoSel = this.state.evento_selecionado?.dados_evento;
                                const config = eventoSel?.dados_programa?.configuracoes 
                                    || eventoSel?.dados_atendimento?.programa?.configuracoes;
                                
                                const aprovaAutomatico = getConfig(config, 'aprova_laudo_automatico', true);
                                const showStatusColumn = !aprovaAutomatico;
                                
                                return (
                                <div className="table-responsive">
                                <Table striped bordered hover size="sm">
                                    <thead>
                                        <tr>
                                            <th>Arquivo</th>
                                            <th className="text-nowrap">Data</th>
                                            <th className="text-nowrap">Tipo</th>
                                            {showStatusColumn && <th className="text-nowrap">Status</th>}
                                            { getCurrentUser().tipo_usuario !== 'prestador' && <th className="text-end text-nowrap" style={{ width: '1%' }}>Opções</th> }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.arquivos.map((arquivo) => {
                                            const dados_user = getCurrentUser();
                                            const usuarioLogadoId = String(dados_user.id);
                                            const arquivoAutorId = String(arquivo.cadastrado_por_id || '');
                                            const isAutor = usuarioLogadoId === arquivoAutorId;
                                            
                                            const validacaoArquivosHabilitada = getConfig(config, 'agendamento.validacao_arquivos', false);

                                            const isNavegadora = ['', 'operador', 'gestor'].includes(dados_user.tipo_usuario);
                                            
                                            const podeAvaliar = (dados_user.tipo_usuario === '' || !isAutor) && arquivo.aprovado === null && isNavegadora;
                                            
                                            const isBloqueadoVisualizarLaudo = isLaudoBloqueadoParaUsuarioAtual(config);

                                            return (
                                                <tr key={arquivo.id}>
                                                    <td>
                                                        {isBloqueadoVisualizarLaudo ? (
                                                            <span className="text-muted" title="Visualização bloqueada">
                                                                {arquivo.nome} <FaExclamationTriangle className="text-warning" />
                                                            </span>
                                                        ) : (
                                                            <a href={arquivo.arquivo} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                                                                {arquivo.nome} <FaDownload size={12} />
                                                            </a>
                                                        )}
                                                    </td>
                                                    <td className="text-nowrap">{formataDataHoraExibicao(arquivo.data)}</td>
                                                    <td className="text-nowrap">{tiposArquivos[arquivo.tipo] || arquivo.tipo}</td>
                                                    {showStatusColumn && (
                                                        <td className="text-nowrap">
                                                            {arquivo.aprovado === true && <Badge bg="success">Aprovado</Badge>}
                                                            {(arquivo.aprovado === null || arquivo.aprovado === undefined) && <Badge bg="warning" text="dark">Pendente</Badge>}
                                                            {arquivo.aprovado === false && (
                                                                <OverlayTrigger placement="top" overlay={<Tooltip>{arquivo.motivo_recusa}</Tooltip>}>
                                                                    <Badge bg="danger" style={{ cursor: 'help' }}>Recusado <FaExclamationTriangle /></Badge>
                                                                </OverlayTrigger>
                                                            )}
                                                        </td>
                                                    )}
                                                    { getCurrentUser().tipo_usuario !== 'prestador' && (
                                                    <td className="text-end text-nowrap">
                                                        <div className="d-flex justify-content-end gap-1">
                                                            {/* Botões de Aprovar/Recusar */}
                                                            {podeAvaliar && validacaoArquivosHabilitada && (
                                                                <>
                                                                    <Button 
                                                                        variant="outline-success" 
                                                                        size="sm" 
                                                                        onClick={() => this.handleAprovarArquivo(arquivo.id)}
                                                                        title="Aprovar"
                                                                    >
                                                                        <FaCheck />
                                                                    </Button>
                                                                    <Button 
                                                                        variant="outline-danger" 
                                                                        size="sm" 
                                                                        onClick={() => this.handleRecusarArquivo(arquivo.id)}
                                                                        title="Recusar"
                                                                    >
                                                                        <FaTimes />
                                                                    </Button>
                                                                </>
                                                            )}
                                                            
                                                            {/* Botões originais de Edição/Exclusão */}
                                                            {(dados_user['tipo_usuario'] == '' || dados_user['tipo_usuario'] === 'operador') && (
                                                                <>
                                                                    <Button variant="outline-primary" size="sm" onClick={() => this.editarArquivo(arquivo)} title="Editar">
                                                                        <FaEdit />
                                                                    </Button>
                                                                    <Button variant="outline-danger" size="sm" onClick={() => this.excluirArquivo(arquivo.id)} title="Excluir">
                                                                        <FaTrash />
                                                                    </Button>
                                                                </>
                                                            )}
                                                        </div>
                                                    </td>
                                                    )}
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            </div>
                            );
                            })()
                        ) : (
                            <p className="text-center text-muted">Nenhum arquivo encontrado.</p>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary-outline" onClick={this.handleCloseModalArquivos}>
                            Fechar
                        </Button>
                        {(() => {
                            const evt = this.state.evento_selecionado?.dados_evento;
                            const configValidacao = getConfig(evt?.dados_programa?.configuracoes || evt?.dados_atendimento?.programa?.configuracoes, 'agendamento.validacao_arquivos', false);
                            
                            const user = getCurrentUser();
                            const podeAdicionar = (['operador', 'gestor', ''].includes(user.tipo_usuario) || (user.tipo_usuario === 'prestador' && configValidacao));
                            
                            const isBloqueadoVisualizarLaudo = isLaudoBloqueadoParaUsuarioAtual(
                                evt?.dados_programa?.configuracoes || evt?.dados_atendimento?.programa?.configuracoes
                            );

                            return podeAdicionar && !isBloqueadoVisualizarLaudo && evt?.situacao !== "cancelado" && (
                                <Button variant="secondary" onClick={() => this.handleShowModalArquivosEdit()}>
                                    <FaPlus /> Cadastrar Novo Arquivo
                                </Button>
                            );
                        })()}
                    </Modal.Footer>
                </Modal>
                </>
                )}

                {/* Modal de Confirmação de Realização de Serviço */}
                <ConfirmarRealizacaoModal
                    show={this.state.showConfirmarRealizacaoModal}
                    onHide={() => this.setState({ showConfirmarRealizacaoModal: false })}
                    agendamento={{
                        id: this.state.evento_selecionado?.agendamento_id,
                        data_agendamento: this.state.evento_selecionado?.dados_evento?.data_agendamento,
                        servico_procedimento_id: this.state.evento_selecionado?.servico_procedimento_id,
                        prestador_id: this.state.evento_selecionado?.dados_evento?.prestador_id,
                        tipo: this.state.evento_selecionado?.dados_evento?.dados_servico_procedimento?.tipo,
                        aplicacao_id: this.state.evento_selecionado?.dados_evento?.aplicacao_id,
                        atendimento_kit_id: this.state.evento_selecionado?.dados_evento?.atendimento_kit_id,
                        atendimento_id: this.state.evento_selecionado?.atendimento_id,
                        dados_servico_procedimento: this.state.evento_selecionado?.dados_evento?.dados_servico_procedimento,
                        dados_prestador: this.state.evento_selecionado?.dados_prestador,
                        dados_programa: this.state.evento_selecionado?.dados_evento?.dados_programa, // Passando dados_programa para acessar configurações
                        etapa_atual: this.state.evento_selecionado?.dados_evento?.etapa_atual,
                    }}
                    contextData={{
                        beneficiario_id: this.state.evento_selecionado?.beneficiario_id,
                        atendimento_id: this.state.evento_selecionado?.atendimento_id,
                        etapa_atual: this.state.evento_selecionado?.dados_evento?.etapa_atual,
                    }}
                    onSuccess={() => {
                        this.setState({ showConfirmarRealizacaoModal: false });
                        this.handleCloseModalAgendamento();
                        this.buscaAgendas(false, 1);
                    }}
                />

                {/* Modal de Formulário Dinâmico de Serviços */}
                <ModalPersonalizadoServicos
                    show={this.state.showModalPersonalizadoServicos}
                    onHide={() => this.setState({ showModalPersonalizadoServicos: false, agendamentoFormularioDinamico: null, formularioDinamicoReadOnly: false })}
                    agendamento={this.state.agendamentoFormularioDinamico}
                    contextData={{
                        atendimento_id: this.state.evento_selecionado?.atendimento_id,
                        etapa_atual: this.state.evento_selecionado?.dados_evento?.etapa_atual,
                    }}
                    onSuccess={() => {
                        this.setState({ showModalPersonalizadoServicos: false, agendamentoFormularioDinamico: null, formularioDinamicoReadOnly: false });
                        this.handleCloseModalAgendamento();
                        this.buscaAgendas(false, 1);
                    }}
                    readOnly={this.state.formularioDinamicoReadOnly}
                />

                {/* Modal de Formulário de Evento para Upload de Arquivo/Laudo */}
                {this.state.showFormularioEvento && (
                    <FormularioEventoModal
                        show={this.state.showFormularioEvento}
                        onHide={() => this.setState({ showFormularioEvento: false, loading: false })}
                        formulario={this.state.formularioEvento}
                        onSuccess={this.handleFormularioEventoSuccess}
                        loading={this.state.loading}
                    />
                )}
            </div>
        );
    }
}

export default withRouter(Agendas);
